// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, urlSearchParamsBodySerializer, formDataBodySerializer } from '@hey-api/client-fetch';
import type { NativeAppleSignInApiAuthAppleNativePostData, NativeAppleChallengeApiAuthAppleNativeChallengePostData, NativeGoogleSignInApiAuthGoogleNativePostData, NativeGoogleChallengeApiAuthGoogleNativeChallengePostData, BugReportApiBugReportPostData, BugReportAttachmentUploadUrlApiBugReportAttachmentsUploadUrlPostData, BugReportAttachmentUploadUrlApiBugReportAttachmentsUploadUrlPostResponse, BugReportAttachmentUploadUrlApiBugReportAttachmentsUploadUrlPostError, CompleteGoogleCalendarConnectionData, CompleteGoogleCalendarConnectionError, StartGoogleCalendarConnectionData, ReadGarmentForEditApiGarmentsGarmentIdEditGetData, ReadGarmentForEditApiGarmentsGarmentIdEditGetResponse, ReadGarmentForEditApiGarmentsGarmentIdEditGetError, EditGarmentTagsApiGarmentsGarmentIdTagsPostData, EditGarmentTagsApiGarmentsGarmentIdTagsPostResponse, EditGarmentTagsApiGarmentsGarmentIdTagsPostError, AcceptLegalApiMembersMeAcceptLegalPostData, DeleteProfileApiMembersMeDeletePostData, PersonalApiMembersMePersonalPostData, PreferencesApiMembersMePreferencesPostData, PresentationApiMembersMePresentationPostData, PrivacyApiMembersMePrivacyPostData, MeasurementsApiMembersMeProfilePostData, ConsumerStudioChatFeedbackData, ConsumerStudioChatFeedbackError, ChangePasswordApiV1AuthChangePasswordPostData, ChangePasswordApiV1AuthChangePasswordPostResponse, ChangePasswordApiV1AuthChangePasswordPostError, ForgotPasswordApiV1AuthForgotPasswordPostData, ForgotPasswordApiV1AuthForgotPasswordPostResponse, ForgotPasswordApiV1AuthForgotPasswordPostError, LoginApiV1AuthLoginPostData, LoginApiV1AuthLoginPostResponse, LoginApiV1AuthLoginPostError, LogoutApiV1AuthLogoutPostData, LogoutApiV1AuthLogoutPostResponse, LogoutApiV1AuthLogoutPostError, RefreshApiV1AuthRefreshPostData, RefreshApiV1AuthRefreshPostResponse, RefreshApiV1AuthRefreshPostError, ResetPasswordApiV1AuthResetPasswordPostData, ResetPasswordApiV1AuthResetPasswordPostResponse, ResetPasswordApiV1AuthResetPasswordPostError, DatabaseApiV1DatabaseGetData, DatabaseApiV1DatabaseGetResponse, HealthApiV1HealthGetData, HealthApiV1HealthGetResponse, AccountDeletionsApiV1InternalAccountDeletionsGetData, AccountDeletionsApiV1InternalAccountDeletionsGetResponse, AccountDeletionsApiV1InternalAccountDeletionsGetError, AccountDeletionApiV1InternalAccountDeletionsRequestIdGetData, AccountDeletionApiV1InternalAccountDeletionsRequestIdGetResponse, AccountDeletionApiV1InternalAccountDeletionsRequestIdGetError, RetryAccountDeletionApiV1InternalAccountDeletionsRequestIdRetryPostData, RetryAccountDeletionApiV1InternalAccountDeletionsRequestIdRetryPostResponse, RetryAccountDeletionApiV1InternalAccountDeletionsRequestIdRetryPostError, AccountsApiV1InternalAccountsGetData, AccountsApiV1InternalAccountsGetResponse, AccountsApiV1InternalAccountsGetError, CreateAccountsBatchApiV1InternalAccountsBatchPostData, CreateAccountsBatchApiV1InternalAccountsBatchPostResponse, CreateAccountsBatchApiV1InternalAccountsBatchPostError, ManageAccountApiV1InternalAccountsIdPatchData, ManageAccountApiV1InternalAccountsIdPatchResponse, ManageAccountApiV1InternalAccountsIdPatchError, IssuePasswordResetLinkApiV1InternalAccountsIdPasswordResetLinkPostData, IssuePasswordResetLinkApiV1InternalAccountsIdPasswordResetLinkPostResponse, IssuePasswordResetLinkApiV1InternalAccountsIdPasswordResetLinkPostError, ActivityLogsApiV1InternalActivityLogsGetData, ActivityLogsApiV1InternalActivityLogsGetResponse, ActivityLogsApiV1InternalActivityLogsGetError, AiCostsApiV1InternalAiCostsGetData, AiCostsApiV1InternalAiCostsGetResponse, AuditRecordsApiV1InternalAuditRecordsGetData, AuditRecordsApiV1InternalAuditRecordsGetResponse, AuditRecordsApiV1InternalAuditRecordsGetError, UsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsGetData, UsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsGetResponse, SetUsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsPutData, SetUsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsPutResponse, SetUsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsPutError, ControlApiV1InternalControlsPostData, ControlApiV1InternalControlsPostResponse, ControlApiV1InternalControlsPostError, DashboardApiV1InternalDashboardGetData, DashboardApiV1InternalDashboardGetResponse, DeletionRequestsApiV1InternalDeletionRequestsGetData, DeletionRequestsApiV1InternalDeletionRequestsGetResponse, DeletionRequestsApiV1InternalDeletionRequestsGetError, RestoreDeletionRequestApiV1InternalDeletionRequestsRequestIdRestorePostData, RestoreDeletionRequestApiV1InternalDeletionRequestsRequestIdRestorePostResponse, RestoreDeletionRequestApiV1InternalDeletionRequestsRequestIdRestorePostError, EmailDeliveriesApiV1InternalEmailDeliveriesGetData, EmailDeliveriesApiV1InternalEmailDeliveriesGetResponse, EmailDeliveriesApiV1InternalEmailDeliveriesGetError, FeatureFlagsApiV1InternalFeatureFlagsGetData, FeatureFlagsApiV1InternalFeatureFlagsGetResponse, ResetFeatureFlagApiV1InternalFeatureFlagsKeyDeleteData, ResetFeatureFlagApiV1InternalFeatureFlagsKeyDeleteResponse, ResetFeatureFlagApiV1InternalFeatureFlagsKeyDeleteError, SetFeatureFlagApiV1InternalFeatureFlagsKeyPutData, SetFeatureFlagApiV1InternalFeatureFlagsKeyPutResponse, SetFeatureFlagApiV1InternalFeatureFlagsKeyPutError, MemberFeedbackApiV1InternalFeedbackGetData, MemberFeedbackApiV1InternalFeedbackGetResponse, MemberFeedbackApiV1InternalFeedbackGetError, TriageBugReportApiV1InternalFeedbackBugReportsReportIdPatchData, TriageBugReportApiV1InternalFeedbackBugReportsReportIdPatchResponse, TriageBugReportApiV1InternalFeedbackBugReportsReportIdPatchError, FailedGarmentsApiV1InternalGarmentsFailedGetData, FailedGarmentsApiV1InternalGarmentsFailedGetResponse, FailedGarmentsApiV1InternalGarmentsFailedGetError, HealthApiV1InternalHealthDashboardGetData, HealthApiV1InternalHealthDashboardGetResponse, LandingStatsApiV1InternalLandingStatsGetData, LandingStatsApiV1InternalLandingStatsGetResponse, LandingStatsApiV1InternalLandingStatsGetError, ListMembersApiV1InternalMembersGetData, ListMembersApiV1InternalMembersGetResponse, ListMembersApiV1InternalMembersGetError, ChangeMemberAccessApiV1InternalMembersMemberIdAccessPostData, ChangeMemberAccessApiV1InternalMembersMemberIdAccessPostResponse, ChangeMemberAccessApiV1InternalMembersMemberIdAccessPostError, MetricsApiV1InternalMetricsDashboardGetData, MetricsApiV1InternalMetricsDashboardGetResponse, ListApiCallLogsApiV1InternalObservabilityApiCallLogsGetData, ListApiCallLogsApiV1InternalObservabilityApiCallLogsGetResponse, ListApiCallLogsApiV1InternalObservabilityApiCallLogsGetError, CorrelationApiV1InternalObservabilityCorrelationsCorrelationIdGetData, CorrelationApiV1InternalObservabilityCorrelationsCorrelationIdGetResponse, CorrelationApiV1InternalObservabilityCorrelationsCorrelationIdGetError, LogLinesApiV1InternalObservabilityLogLinesGetData, LogLinesApiV1InternalObservabilityLogLinesGetResponse, LogLinesApiV1InternalObservabilityLogLinesGetError, MobileTelemetryApiV1InternalObservabilityMobileTelemetryGetData, MobileTelemetryApiV1InternalObservabilityMobileTelemetryGetResponse, MobileTelemetryApiV1InternalObservabilityMobileTelemetryGetError, ListScheduledOnboardingSessionsApiV1InternalOnboardingSessionsGetData, ListScheduledOnboardingSessionsApiV1InternalOnboardingSessionsGetResponse, ListScheduledOnboardingSessionsApiV1InternalOnboardingSessionsGetError, CancelUserOnboardingSessionApiV1InternalOnboardingSessionsIdCancelPostData, CancelUserOnboardingSessionApiV1InternalOnboardingSessionsIdCancelPostResponse, CancelUserOnboardingSessionApiV1InternalOnboardingSessionsIdCancelPostError, RescheduleUserOnboardingSessionApiV1InternalOnboardingSessionsIdReschedulePostData, RescheduleUserOnboardingSessionApiV1InternalOnboardingSessionsIdReschedulePostResponse, RescheduleUserOnboardingSessionApiV1InternalOnboardingSessionsIdReschedulePostError, ListJobsApiV1InternalOperatorWorkflowJobsJobsGetData, ListJobsApiV1InternalOperatorWorkflowJobsJobsGetResponse, ListJobsApiV1InternalOperatorWorkflowJobsJobsGetError, GetJobApiV1InternalOperatorWorkflowJobsJobsJobIdGetData, GetJobApiV1InternalOperatorWorkflowJobsJobsJobIdGetResponse, GetJobApiV1InternalOperatorWorkflowJobsJobsJobIdGetError, CancelJobApiV1InternalOperatorWorkflowJobsJobsJobIdCancelPostData, CancelJobApiV1InternalOperatorWorkflowJobsJobsJobIdCancelPostResponse, CancelJobApiV1InternalOperatorWorkflowJobsJobsJobIdCancelPostError, GetCheckpointMediaApiV1InternalOperatorWorkflowJobsJobsJobIdCheckpointMediaGetData, GetCheckpointMediaApiV1InternalOperatorWorkflowJobsJobsJobIdCheckpointMediaGetError, ResumeJobApiV1InternalOperatorWorkflowJobsJobsJobIdResumePostData, ResumeJobApiV1InternalOperatorWorkflowJobsJobsJobIdResumePostResponse, ResumeJobApiV1InternalOperatorWorkflowJobsJobsJobIdResumePostError, RetryJobApiV1InternalOperatorWorkflowJobsJobsJobIdRetryPostData, RetryJobApiV1InternalOperatorWorkflowJobsJobsJobIdRetryPostResponse, RetryJobApiV1InternalOperatorWorkflowJobsJobsJobIdRetryPostError, ListWorkflowFamiliesApiV1InternalOperatorWorkflowJobsWorkflowsGetData, ListWorkflowFamiliesApiV1InternalOperatorWorkflowJobsWorkflowsGetResponse, PilotControlsApiV1InternalPilotControlsGetData, PilotControlsApiV1InternalPilotControlsGetResponse, ResolveReferencesApiV1InternalReferencesResolvePostData, ResolveReferencesApiV1InternalReferencesResolvePostResponse, ResolveReferencesApiV1InternalReferencesResolvePostError, GetSchedulingOptionsApiV1InternalSchedulingOptionsGetData, GetSchedulingOptionsApiV1InternalSchedulingOptionsGetResponse, RecentSearchesApiV1InternalSearchesRecentGetData, RecentSearchesApiV1InternalSearchesRecentGetResponse, RecentSearchesApiV1InternalSearchesRecentGetError, ProvisionStagingSmokePrincipalsApiV1InternalStagingSmokePrincipalsPostData, ProvisionStagingSmokePrincipalsApiV1InternalStagingSmokePrincipalsPostResponse, ProvisionStagingSmokePrincipalsApiV1InternalStagingSmokePrincipalsPostError, PairApiV1InternalStylistHierarchyPairingsPostData, PairApiV1InternalStylistHierarchyPairingsPostResponse, PairApiV1InternalStylistHierarchyPairingsPostError, SetProfileApiV1InternalStylistHierarchyProfilesStylistIdPutData, SetProfileApiV1InternalStylistHierarchyProfilesStylistIdPutResponse, SetProfileApiV1InternalStylistHierarchyProfilesStylistIdPutError, RosterApiV1InternalStylistHierarchyRosterGetData, RosterApiV1InternalStylistHierarchyRosterGetResponse, RosterApiV1InternalStylistHierarchyRosterGetError, RoutingRulesApiV1InternalStylistHierarchyRoutingRulesGetData, RoutingRulesApiV1InternalStylistHierarchyRoutingRulesGetResponse, RoutingRulesApiV1InternalStylistHierarchyRoutingRulesGetError, WriteRuleApiV1InternalStylistHierarchyRoutingRulesSourceTypePutData, WriteRuleApiV1InternalStylistHierarchyRoutingRulesSourceTypePutResponse, WriteRuleApiV1InternalStylistHierarchyRoutingRulesSourceTypePutError, AdminTasksApiV1InternalStylistHierarchyTasksGetData, AdminTasksApiV1InternalStylistHierarchyTasksGetResponse, AdminTasksApiV1InternalStylistHierarchyTasksGetError, CreateTaskApiV1InternalStylistHierarchyTasksPostData, CreateTaskApiV1InternalStylistHierarchyTasksPostResponse, CreateTaskApiV1InternalStylistHierarchyTasksPostError, ReassignApiV1InternalStylistHierarchyTasksTaskIdReassignPostData, ReassignApiV1InternalStylistHierarchyTasksTaskIdReassignPostResponse, ReassignApiV1InternalStylistHierarchyTasksTaskIdReassignPostError, ListStylistsApiV1InternalStylistsGetData, ListStylistsApiV1InternalStylistsGetResponse, ListStylistsApiV1InternalStylistsGetError, CreateStylistApiV1InternalStylistsPostData, CreateStylistApiV1InternalStylistsPostResponse, CreateStylistApiV1InternalStylistsPostError, ListAvailableStylistsApiV1InternalStylistsAvailableGetData, ListAvailableStylistsApiV1InternalStylistsAvailableGetResponse, ListAvailableStylistsApiV1InternalStylistsAvailableGetError, GetStylistApiV1InternalStylistsIdGetData, GetStylistApiV1InternalStylistsIdGetResponse, GetStylistApiV1InternalStylistsIdGetError, UpdateStylistApiV1InternalStylistsIdPatchData, UpdateStylistApiV1InternalStylistsIdPatchResponse, UpdateStylistApiV1InternalStylistsIdPatchError, ListStylistMembersApiV1InternalStylistsIdMembersGetData, ListStylistMembersApiV1InternalStylistsIdMembersGetResponse, ListStylistMembersApiV1InternalStylistsIdMembersGetError, AssignStylistMembersApiV1InternalStylistsIdMembersPostData, AssignStylistMembersApiV1InternalStylistsIdMembersPostResponse, AssignStylistMembersApiV1InternalStylistsIdMembersPostError, StylistOversightApiV1InternalStylistsIdOversightGetData, StylistOversightApiV1InternalStylistsIdOversightGetResponse, StylistOversightApiV1InternalStylistsIdOversightGetError, ListUsersApiV1InternalUsersGetData, ListUsersApiV1InternalUsersGetResponse, ListUsersApiV1InternalUsersGetError, CreateUserApiV1InternalUsersPostData, CreateUserApiV1InternalUsersPostResponse, CreateUserApiV1InternalUsersPostError, GetUserApiV1InternalUsersIdGetData, GetUserApiV1InternalUsersIdGetResponse, GetUserApiV1InternalUsersIdGetError, UpdateUserApiV1InternalUsersIdPatchData, UpdateUserApiV1InternalUsersIdPatchResponse, UpdateUserApiV1InternalUsersIdPatchError, EnhanceMemberAvatarApiV1InternalUsersIdAvatarEnhancePostData, EnhanceMemberAvatarApiV1InternalUsersIdAvatarEnhancePostResponse, EnhanceMemberAvatarApiV1InternalUsersIdAvatarEnhancePostError, UndoMemberAvatarImprovementApiV1InternalUsersIdAvatarUndoPostData, UndoMemberAvatarImprovementApiV1InternalUsersIdAvatarUndoPostResponse, UndoMemberAvatarImprovementApiV1InternalUsersIdAvatarUndoPostError, RecomputeMemberBodyShapeApiV1InternalUsersIdBodyShapeRecomputePostData, RecomputeMemberBodyShapeApiV1InternalUsersIdBodyShapeRecomputePostResponse, RecomputeMemberBodyShapeApiV1InternalUsersIdBodyShapeRecomputePostError, MemberChatApiV1InternalUsersIdChatGetData, MemberChatApiV1InternalUsersIdChatGetResponse, MemberChatApiV1InternalUsersIdChatGetError, RegenerateMemberDailyLookApiV1InternalUsersIdDailyLookRegeneratePostData, RegenerateMemberDailyLookApiV1InternalUsersIdDailyLookRegeneratePostResponse, RegenerateMemberDailyLookApiV1InternalUsersIdDailyLookRegeneratePostError, MemberDailyLooksApiV1InternalUsersIdDailyLooksGetData, MemberDailyLooksApiV1InternalUsersIdDailyLooksGetResponse, MemberDailyLooksApiV1InternalUsersIdDailyLooksGetError, RequestMemberDataExportApiV1InternalUsersIdDataExportPostData, RequestMemberDataExportApiV1InternalUsersIdDataExportPostResponse, RequestMemberDataExportApiV1InternalUsersIdDataExportPostError, MemberDataExportStatusApiV1InternalUsersIdDataExportsExportIdGetData, MemberDataExportStatusApiV1InternalUsersIdDataExportsExportIdGetResponse, MemberDataExportStatusApiV1InternalUsersIdDataExportsExportIdGetError, DownloadMemberDataExportApiV1InternalUsersIdDataExportsExportIdDownloadGetData, DownloadMemberDataExportApiV1InternalUsersIdDataExportsExportIdDownloadGetResponse, DownloadMemberDataExportApiV1InternalUsersIdDataExportsExportIdDownloadGetError, RequestMemberAccountDeletionApiV1InternalUsersIdDeletionRequestPostData, RequestMemberAccountDeletionApiV1InternalUsersIdDeletionRequestPostResponse, RequestMemberAccountDeletionApiV1InternalUsersIdDeletionRequestPostError, MemberGarmentSetsApiV1InternalUsersIdGarmentSetsGetData, MemberGarmentSetsApiV1InternalUsersIdGarmentSetsGetResponse, MemberGarmentSetsApiV1InternalUsersIdGarmentSetsGetError, CreateMemberGarmentSetApiV1InternalUsersIdGarmentSetsPostData, CreateMemberGarmentSetApiV1InternalUsersIdGarmentSetsPostResponse, CreateMemberGarmentSetApiV1InternalUsersIdGarmentSetsPostError, RetireMemberGarmentSetApiV1InternalUsersIdGarmentSetsSetIdDeleteData, RetireMemberGarmentSetApiV1InternalUsersIdGarmentSetsSetIdDeleteResponse, RetireMemberGarmentSetApiV1InternalUsersIdGarmentSetsSetIdDeleteError, CreateMemberLookFolderApiV1InternalUsersIdLookFoldersPostData, CreateMemberLookFolderApiV1InternalUsersIdLookFoldersPostResponse, CreateMemberLookFolderApiV1InternalUsersIdLookFoldersPostError, MutateMemberLookFolderMembershipApiV1InternalUsersIdLookFoldersMembershipPostData, MutateMemberLookFolderMembershipApiV1InternalUsersIdLookFoldersMembershipPostResponse, MutateMemberLookFolderMembershipApiV1InternalUsersIdLookFoldersMembershipPostError, ReadMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesGetData, ReadMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesGetResponse, ReadMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesGetError, UpdateMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesPutData, UpdateMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesPutResponse, UpdateMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesPutError, MemberOnboardingApiV1InternalUsersIdOnboardingGetData, MemberOnboardingApiV1InternalUsersIdOnboardingGetResponse, MemberOnboardingApiV1InternalUsersIdOnboardingGetError, ScheduleUserOnboardingSessionApiV1InternalUsersIdOnboardingSessionPostData, ScheduleUserOnboardingSessionApiV1InternalUsersIdOnboardingSessionPostResponse, ScheduleUserOnboardingSessionApiV1InternalUsersIdOnboardingSessionPostError, MemberOnboardingAnswersApiV1InternalUsersIdOnboardingAnswersGetData, MemberOnboardingAnswersApiV1InternalUsersIdOnboardingAnswersGetResponse, MemberOnboardingAnswersApiV1InternalUsersIdOnboardingAnswersGetError, SaveMemberOnboardingCheckpointApiV1InternalUsersIdOnboardingCheckpointPutData, SaveMemberOnboardingCheckpointApiV1InternalUsersIdOnboardingCheckpointPutResponse, SaveMemberOnboardingCheckpointApiV1InternalUsersIdOnboardingCheckpointPutError, CompleteMemberOnboardingApiV1InternalUsersIdOnboardingCompletePostData, CompleteMemberOnboardingApiV1InternalUsersIdOnboardingCompletePostResponse, CompleteMemberOnboardingApiV1InternalUsersIdOnboardingCompletePostError, NudgeMemberOnboardingApiV1InternalUsersIdOnboardingNudgePostData, NudgeMemberOnboardingApiV1InternalUsersIdOnboardingNudgePostResponse, NudgeMemberOnboardingApiV1InternalUsersIdOnboardingNudgePostError, ResetMemberOnboardingApiV1InternalUsersIdOnboardingResetPostData, ResetMemberOnboardingApiV1InternalUsersIdOnboardingResetPostResponse, ResetMemberOnboardingApiV1InternalUsersIdOnboardingResetPostError, MemberOutfitsApiV1InternalUsersIdOutfitsGetData, MemberOutfitsApiV1InternalUsersIdOutfitsGetResponse, MemberOutfitsApiV1InternalUsersIdOutfitsGetError, CreateMemberOutfitApiV1InternalUsersIdOutfitsPostData, CreateMemberOutfitApiV1InternalUsersIdOutfitsPostResponse, CreateMemberOutfitApiV1InternalUsersIdOutfitsPostError, BookmarkMemberOutfitApiV1InternalUsersIdOutfitsBookmarkPostData, BookmarkMemberOutfitApiV1InternalUsersIdOutfitsBookmarkPostResponse, BookmarkMemberOutfitApiV1InternalUsersIdOutfitsBookmarkPostError, BulkMemberOutfitsApiV1InternalUsersIdOutfitsBulkPostData, BulkMemberOutfitsApiV1InternalUsersIdOutfitsBulkPostResponse, BulkMemberOutfitsApiV1InternalUsersIdOutfitsBulkPostError, RegenerateMemberOutfitApiV1InternalUsersIdOutfitsRegeneratePostData, RegenerateMemberOutfitApiV1InternalUsersIdOutfitsRegeneratePostResponse, RegenerateMemberOutfitApiV1InternalUsersIdOutfitsRegeneratePostError, MarkMemberOutfitWornApiV1InternalUsersIdOutfitsWearPostData, MarkMemberOutfitWornApiV1InternalUsersIdOutfitsWearPostResponse, MarkMemberOutfitWornApiV1InternalUsersIdOutfitsWearPostError, DeleteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdDeleteData, DeleteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdDeleteResponse, DeleteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdDeleteError, MemberOutfitApiV1InternalUsersIdOutfitsOutfitIdGetData, MemberOutfitApiV1InternalUsersIdOutfitsOutfitIdGetResponse, MemberOutfitApiV1InternalUsersIdOutfitsOutfitIdGetError, SetMemberOutfitGarmentsApiV1InternalUsersIdOutfitsOutfitIdGarmentsPostData, SetMemberOutfitGarmentsApiV1InternalUsersIdOutfitsOutfitIdGarmentsPostResponse, SetMemberOutfitGarmentsApiV1InternalUsersIdOutfitsOutfitIdGarmentsPostError, PromoteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdPromotePostData, PromoteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdPromotePostResponse, PromoteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdPromotePostError, EditMemberOutfitTagsApiV1InternalUsersIdOutfitsOutfitIdTagsPatchData, EditMemberOutfitTagsApiV1InternalUsersIdOutfitsOutfitIdTagsPatchResponse, EditMemberOutfitTagsApiV1InternalUsersIdOutfitsOutfitIdTagsPatchError, RenameMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdTitlePatchData, RenameMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdTitlePatchResponse, RenameMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdTitlePatchError, SetMemberProfileLocationApiV1InternalUsersIdProfileLocationPutData, SetMemberProfileLocationApiV1InternalUsersIdProfileLocationPutResponse, SetMemberProfileLocationApiV1InternalUsersIdProfileLocationPutError, EditMemberProfileMeasurementsApiV1InternalUsersIdProfileMeasurementsPutData, EditMemberProfileMeasurementsApiV1InternalUsersIdProfileMeasurementsPutResponse, EditMemberProfileMeasurementsApiV1InternalUsersIdProfileMeasurementsPutError, EditMemberPersonalProfileApiV1InternalUsersIdProfilePersonalPutData, EditMemberPersonalProfileApiV1InternalUsersIdProfilePersonalPutResponse, EditMemberPersonalProfileApiV1InternalUsersIdProfilePersonalPutError, EditMemberProfilePresentationApiV1InternalUsersIdProfilePresentationPutData, EditMemberProfilePresentationApiV1InternalUsersIdProfilePresentationPutResponse, EditMemberProfilePresentationApiV1InternalUsersIdProfilePresentationPutError, EditMemberProfilePrivacyApiV1InternalUsersIdProfilePrivacyPutData, EditMemberProfilePrivacyApiV1InternalUsersIdProfilePrivacyPutResponse, EditMemberProfilePrivacyApiV1InternalUsersIdProfilePrivacyPutError, MemberSearchesApiV1InternalUsersIdSearchesGetData, MemberSearchesApiV1InternalUsersIdSearchesGetResponse, MemberSearchesApiV1InternalUsersIdSearchesGetError, MemberSearchApiV1InternalUsersIdSearchesSearchIdGetData, MemberSearchApiV1InternalUsersIdSearchesSearchIdGetResponse, MemberSearchApiV1InternalUsersIdSearchesSearchIdGetError, RerunMemberSearchApiV1InternalUsersIdSearchesSearchIdRerunPostData, RerunMemberSearchApiV1InternalUsersIdSearchesSearchIdRerunPostResponse, RerunMemberSearchApiV1InternalUsersIdSearchesSearchIdRerunPostError, UploadMemberTwinPhotoData, UploadMemberTwinPhotoResponse, UploadMemberTwinPhotoError, MemberUsageLimitsApiV1InternalUsersIdUsageLimitsGetData, MemberUsageLimitsApiV1InternalUsersIdUsageLimitsGetResponse, MemberUsageLimitsApiV1InternalUsersIdUsageLimitsGetError, SetMemberUsageLimitsApiV1InternalUsersIdUsageLimitsPutData, SetMemberUsageLimitsApiV1InternalUsersIdUsageLimitsPutResponse, SetMemberUsageLimitsApiV1InternalUsersIdUsageLimitsPutError, MemberWardrobeApiV1InternalUsersIdWardrobeGetData, MemberWardrobeApiV1InternalUsersIdWardrobeGetResponse, MemberWardrobeApiV1InternalUsersIdWardrobeGetError, MemberWardrobeFoldersApiV1InternalUsersIdWardrobeFoldersGetData, MemberWardrobeFoldersApiV1InternalUsersIdWardrobeFoldersGetResponse, MemberWardrobeFoldersApiV1InternalUsersIdWardrobeFoldersGetError, CreateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersPostData, CreateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersPostResponse, CreateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersPostError, DeleteMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdDeleteData, DeleteMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdDeleteResponse, DeleteMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdDeleteError, MemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdGetData, MemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdGetResponse, MemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdGetError, UpdateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdPatchData, UpdateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdPatchResponse, UpdateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdPatchError, RemoveMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdDeleteData, RemoveMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdDeleteResponse, RemoveMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdDeleteError, PutMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdPutData, PutMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdPutResponse, PutMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdPutError, MutateMemberWardrobeFolderOutfitsApiV1InternalUsersIdWardrobeFoldersFolderIdOutfitsPostData, MutateMemberWardrobeFolderOutfitsApiV1InternalUsersIdWardrobeFoldersFolderIdOutfitsPostResponse, MutateMemberWardrobeFolderOutfitsApiV1InternalUsersIdWardrobeFoldersFolderIdOutfitsPostError, BulkMemberGarmentsApiV1InternalUsersIdWardrobeGarmentsBulkPostData, BulkMemberGarmentsApiV1InternalUsersIdWardrobeGarmentsBulkPostResponse, BulkMemberGarmentsApiV1InternalUsersIdWardrobeGarmentsBulkPostError, DeleteMemberGarmentsBulkApiV1InternalUsersIdWardrobeGarmentsDeleteBulkPostData, DeleteMemberGarmentsBulkApiV1InternalUsersIdWardrobeGarmentsDeleteBulkPostResponse, DeleteMemberGarmentsBulkApiV1InternalUsersIdWardrobeGarmentsDeleteBulkPostError, RemoveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdDeleteData, RemoveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdDeleteResponse, RemoveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdDeleteError, EditGarmentQualityOverrideApiV1InternalUsersIdWardrobeGarmentsGarmentIdPatchData, EditGarmentQualityOverrideApiV1InternalUsersIdWardrobeGarmentsGarmentIdPatchResponse, EditGarmentQualityOverrideApiV1InternalUsersIdWardrobeGarmentsGarmentIdPatchError, ArchiveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdArchivePostData, ArchiveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdArchivePostResponse, ArchiveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdArchivePostError, MemberGarmentPairingsApiV1InternalUsersIdWardrobeGarmentsGarmentIdPairingsGetData, MemberGarmentPairingsApiV1InternalUsersIdWardrobeGarmentsGarmentIdPairingsGetResponse, MemberGarmentPairingsApiV1InternalUsersIdWardrobeGarmentsGarmentIdPairingsGetError, DeleteMemberGarmentPermanentlyApiV1InternalUsersIdWardrobeGarmentsGarmentIdPermanentDeleteData, DeleteMemberGarmentPermanentlyApiV1InternalUsersIdWardrobeGarmentsGarmentIdPermanentDeleteResponse, DeleteMemberGarmentPermanentlyApiV1InternalUsersIdWardrobeGarmentsGarmentIdPermanentDeleteError, ReprocessMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdReprocessPostData, ReprocessMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdReprocessPostResponse, ReprocessMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdReprocessPostError, RequeueMemberGarmentIngestionApiV1InternalUsersIdWardrobeGarmentsGarmentIdRequeueIngestionPostData, RequeueMemberGarmentIngestionApiV1InternalUsersIdWardrobeGarmentsGarmentIdRequeueIngestionPostResponse, RequeueMemberGarmentIngestionApiV1InternalUsersIdWardrobeGarmentsGarmentIdRequeueIngestionPostError, RestoreMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdRestorePostData, RestoreMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdRestorePostResponse, RestoreMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdRestorePostError, EditMemberGarmentTagsApiV1InternalUsersIdWardrobeGarmentsGarmentIdTagsPostData, EditMemberGarmentTagsApiV1InternalUsersIdWardrobeGarmentsGarmentIdTagsPostResponse, EditMemberGarmentTagsApiV1InternalUsersIdWardrobeGarmentsGarmentIdTagsPostError, MemberWardrobeSummaryApiV1InternalUsersIdWardrobeSummaryGetData, MemberWardrobeSummaryApiV1InternalUsersIdWardrobeSummaryGetResponse, MemberWardrobeSummaryApiV1InternalUsersIdWardrobeSummaryGetError, MemberDeletionRequestApiV1InternalUsersMemberIdDeletionRequestGetData, MemberDeletionRequestApiV1InternalUsersMemberIdDeletionRequestGetResponse, MemberDeletionRequestApiV1InternalUsersMemberIdDeletionRequestGetError, ListWardrobeBulkImportsApiV1InternalWardrobeBulkImportsGetData, ListWardrobeBulkImportsApiV1InternalWardrobeBulkImportsGetResponse, ListWardrobeBulkImportsApiV1InternalWardrobeBulkImportsGetError, CreateWardrobeBulkImportApiV1InternalWardrobeBulkImportsPostData, CreateWardrobeBulkImportApiV1InternalWardrobeBulkImportsPostResponse, CreateWardrobeBulkImportApiV1InternalWardrobeBulkImportsPostError, GetWardrobeBulkImportApiV1InternalWardrobeBulkImportsImportIdGetData, GetWardrobeBulkImportApiV1InternalWardrobeBulkImportsImportIdGetResponse, GetWardrobeBulkImportApiV1InternalWardrobeBulkImportsImportIdGetError, ListWardrobeBulkImportItemsApiV1InternalWardrobeBulkImportsImportIdItemsGetData, ListWardrobeBulkImportItemsApiV1InternalWardrobeBulkImportsImportIdItemsGetResponse, ListWardrobeBulkImportItemsApiV1InternalWardrobeBulkImportsImportIdItemsGetError, WardrobeCompositionApiV1InternalWardrobeCompositionGetData, WardrobeCompositionApiV1InternalWardrobeCompositionGetResponse, WardrobeCompositionGarmentsApiV1InternalWardrobeCompositionGarmentsGetData, WardrobeCompositionGarmentsApiV1InternalWardrobeCompositionGarmentsGetResponse, WardrobeCompositionGarmentsApiV1InternalWardrobeCompositionGarmentsGetError, CreateMemberGarmentApiV1InternalWardrobeMembersMemberIdGarmentsPostData, CreateMemberGarmentApiV1InternalWardrobeMembersMemberIdGarmentsPostResponse, CreateMemberGarmentApiV1InternalWardrobeMembersMemberIdGarmentsPostError, ListGarmentQualityCheckApiV1InternalWardrobeQualityCheckGetData, ListGarmentQualityCheckApiV1InternalWardrobeQualityCheckGetResponse, ListGarmentQualityCheckApiV1InternalWardrobeQualityCheckGetError, ApplyGarmentQualityCheckActionsApiV1InternalWardrobeQualityCheckActionsPostData, ApplyGarmentQualityCheckActionsApiV1InternalWardrobeQualityCheckActionsPostResponse, ApplyGarmentQualityCheckActionsApiV1InternalWardrobeQualityCheckActionsPostError, ListJobsApiV1InternalWorkflowJobsJobsGetData, ListJobsApiV1InternalWorkflowJobsJobsGetResponse, ListJobsApiV1InternalWorkflowJobsJobsGetError, GetJobApiV1InternalWorkflowJobsJobsJobIdGetData, GetJobApiV1InternalWorkflowJobsJobsJobIdGetResponse, GetJobApiV1InternalWorkflowJobsJobsJobIdGetError, CancelJobApiV1InternalWorkflowJobsJobsJobIdCancelPostData, CancelJobApiV1InternalWorkflowJobsJobsJobIdCancelPostResponse, CancelJobApiV1InternalWorkflowJobsJobsJobIdCancelPostError, GetCheckpointMediaApiV1InternalWorkflowJobsJobsJobIdCheckpointMediaGetData, GetCheckpointMediaApiV1InternalWorkflowJobsJobsJobIdCheckpointMediaGetError, ResumeJobApiV1InternalWorkflowJobsJobsJobIdResumePostData, ResumeJobApiV1InternalWorkflowJobsJobsJobIdResumePostResponse, ResumeJobApiV1InternalWorkflowJobsJobsJobIdResumePostError, RetryJobApiV1InternalWorkflowJobsJobsJobIdRetryPostData, RetryJobApiV1InternalWorkflowJobsJobsJobIdRetryPostResponse, RetryJobApiV1InternalWorkflowJobsJobsJobIdRetryPostError, ListWorkflowFamiliesApiV1InternalWorkflowJobsWorkflowsGetData, ListWorkflowFamiliesApiV1InternalWorkflowJobsWorkflowsGetResponse, ExplorerApiV1InternalExplorerGetData, ExplorerApiV1InternalExplorerGetResponse, ExplorerApiV1InternalExplorerGetError, LivenessApiV1LivenessGetData, LivenessApiV1LivenessGetResponse, CreateMediaUploadApiV1MediaUploadsPostData, CreateMediaUploadApiV1MediaUploadsPostResponse, CreateMediaUploadApiV1MediaUploadsPostError, CompleteMediaUploadApiV1MediaUploadsIdCompletePostData, CompleteMediaUploadApiV1MediaUploadsIdCompletePostResponse, CompleteMediaUploadApiV1MediaUploadsIdCompletePostError, ReadinessApiV1ReadinessGetData, ReadinessApiV1ReadinessGetResponse, RedisHealthApiV1RedisGetData, RedisHealthApiV1RedisGetResponse, StorageApiV1StorageGetData, StorageApiV1StorageGetResponse, DashboardApiV1StylistDashboardGetData, DashboardApiV1StylistDashboardGetResponse, DashboardApiV1StylistDashboardGetError, MemberApiV1StylistMembersUserIdGetData, MemberApiV1StylistMembersUserIdGetResponse, MemberApiV1StylistMembersUserIdGetError, DayAheadQueueApiV1StylistOotdDayAheadQueueGetData, DayAheadQueueApiV1StylistOotdDayAheadQueueGetResponse, DayAheadQueueApiV1StylistOotdDayAheadQueueGetError, DayAheadSlotApiV1StylistOotdDayAheadSlotIdGetData, DayAheadSlotApiV1StylistOotdDayAheadSlotIdGetResponse, DayAheadSlotApiV1StylistOotdDayAheadSlotIdGetError, DayAheadDecisionApiV1StylistOotdDayAheadSlotIdDecisionPostData, DayAheadDecisionApiV1StylistOotdDayAheadSlotIdDecisionPostResponse, DayAheadDecisionApiV1StylistOotdDayAheadSlotIdDecisionPostError, DayAheadRejectApiV1StylistOotdDayAheadSlotIdRejectPostData, DayAheadRejectApiV1StylistOotdDayAheadSlotIdRejectPostResponse, DayAheadRejectApiV1StylistOotdDayAheadSlotIdRejectPostError, DayAheadWardrobeApiV1StylistOotdDayAheadSlotIdWardrobeGetData, DayAheadWardrobeApiV1StylistOotdDayAheadSlotIdWardrobeGetResponse, DayAheadWardrobeApiV1StylistOotdDayAheadSlotIdWardrobeGetError, CreditLookApiV1StylistWorkbenchLooksOutfitIdCreditPostData, CreditLookApiV1StylistWorkbenchLooksOutfitIdCreditPostResponse, CreditLookApiV1StylistWorkbenchLooksOutfitIdCreditPostError, ReplaceLookApiV1StylistWorkbenchLooksOutfitIdReplacePostData, ReplaceLookApiV1StylistWorkbenchLooksOutfitIdReplacePostResponse, ReplaceLookApiV1StylistWorkbenchLooksOutfitIdReplacePostError, RemoveCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdDeleteData, RemoveCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdDeleteResponse, RemoveCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdDeleteError, UpsertCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdPutData, UpsertCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdPutResponse, UpsertCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdPutError, CreateLookApiV1StylistWorkbenchMembersMemberIdLooksPostData, CreateLookApiV1StylistWorkbenchMembersMemberIdLooksPostResponse, CreateLookApiV1StylistWorkbenchMembersMemberIdLooksPostError, StateApiV1StylistWorkbenchStateGetData, StateApiV1StylistWorkbenchStateGetResponse, StateApiV1StylistWorkbenchStateGetError, AcceptThreadApiV1StylistWorkbenchThreadsThreadIdAcceptPostData, AcceptThreadApiV1StylistWorkbenchThreadsThreadIdAcceptPostResponse, AcceptThreadApiV1StylistWorkbenchThreadsThreadIdAcceptPostError, PublishCartApiV1StylistWorkbenchThreadsThreadIdCartPublishPostData, PublishCartApiV1StylistWorkbenchThreadsThreadIdCartPublishPostResponse, PublishCartApiV1StylistWorkbenchThreadsThreadIdCartPublishPostError, SendMessageApiV1StylistWorkbenchThreadsThreadIdMessagesPostData, SendMessageApiV1StylistWorkbenchThreadsThreadIdMessagesPostResponse, SendMessageApiV1StylistWorkbenchThreadsThreadIdMessagesPostError, SubscriptionApiV1SubscriptionsGetData, SubscriptionApiV1SubscriptionsGetResponse, BillHistoryApiV1SubscriptionsBillHistoryGetData, BillHistoryApiV1SubscriptionsBillHistoryGetResponse, CancelSubscriptionApiV1SubscriptionsCancelPostData, CancelSubscriptionApiV1SubscriptionsCancelPostResponse, SubscriptionCheckoutApiV1SubscriptionsCheckoutPostData, SubscriptionCheckoutApiV1SubscriptionsCheckoutPostError, SubscriptionPlansApiV1SubscriptionsPlansGetData, IngestMobileTelemetryBatchApiV1TelemetryMobileBatchesPostData, IngestMobileTelemetryBatchApiV1TelemetryMobileBatchesPostResponse, IngestMobileTelemetryBatchApiV1TelemetryMobileBatchesPostError, VersionApiV1VersionGetData, VersionApiV1VersionGetResponse, ListFoldersApiV1WardrobeFoldersGetData, ListFoldersApiV1WardrobeFoldersGetResponse, ListFoldersApiV1WardrobeFoldersGetError, CreateFolderApiV1WardrobeFoldersPostData, CreateFolderApiV1WardrobeFoldersPostResponse, CreateFolderApiV1WardrobeFoldersPostError, DeleteFolderApiV1WardrobeFoldersFolderIdDeleteData, DeleteFolderApiV1WardrobeFoldersFolderIdDeleteResponse, DeleteFolderApiV1WardrobeFoldersFolderIdDeleteError, UpdateFolderApiV1WardrobeFoldersFolderIdPatchData, UpdateFolderApiV1WardrobeFoldersFolderIdPatchResponse, UpdateFolderApiV1WardrobeFoldersFolderIdPatchError, GetFolderDetailApiV1WardrobeFoldersFolderIdDetailGetData, GetFolderDetailApiV1WardrobeFoldersFolderIdDetailGetResponse, GetFolderDetailApiV1WardrobeFoldersFolderIdDetailGetError, RemoveFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsDeleteData, RemoveFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsDeleteResponse, RemoveFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsDeleteError, FileFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsPostData, FileFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsPostResponse, FileFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsPostError, MailgunWebhookApiV1WebhooksMailgunPostData, MailgunWebhookApiV1WebhooksMailgunPostResponse, MailgunWebhookApiV1WebhooksMailgunPostError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Native Apple Sign In
 */
export const nativeAppleSignInApiAuthAppleNativePost = <ThrowOnError extends boolean = false>(options?: Options<NativeAppleSignInApiAuthAppleNativePostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/api/auth/apple/native',
        ...options
    });
};

/**
 * Native Apple Challenge
 * The single-use nonce source for Sign in with Apple; the client sends Apple
 * its SHA-256 hex digest, which comes back as the identity token's `nonce`.
 */
export const nativeAppleChallengeApiAuthAppleNativeChallengePost = <ThrowOnError extends boolean = false>(options?: Options<NativeAppleChallengeApiAuthAppleNativeChallengePostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/api/auth/apple/native/challenge',
        ...options
    });
};

/**
 * Native Google Sign In
 */
export const nativeGoogleSignInApiAuthGoogleNativePost = <ThrowOnError extends boolean = false>(options?: Options<NativeGoogleSignInApiAuthGoogleNativePostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/api/auth/google/native',
        ...options
    });
};

/**
 * Native Google Challenge
 */
export const nativeGoogleChallengeApiAuthGoogleNativeChallengePost = <ThrowOnError extends boolean = false>(options?: Options<NativeGoogleChallengeApiAuthGoogleNativeChallengePostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/api/auth/google/native/challenge',
        ...options
    });
};

/**
 * Bug Report
 * Store a problem report. `attachment_refs` are refs from
 * `POST /api/bug-report/attachments/upload-url`, each already uploaded: a ref that is not
 * the member's is 400 `invalid_bug_report_attachment`, and one not uploaded yet is 400
 * `bug_report_attachment_missing`.
 */
export const bugReportApiBugReportPost = <ThrowOnError extends boolean = false>(options: Options<BugReportApiBugReportPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/bug-report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Bug Report Attachment Upload Url
 * A presigned PUT for one image to attach to a problem report: JPEG, PNG, HEIC or WebP,
 * at most 10 MB. PUT exactly `size_bytes` bytes with the same `Content-Type`, then send
 * `ref` in the report's `attachment_refs`. Anything else is 422.
 */
export const bugReportAttachmentUploadUrlApiBugReportAttachmentsUploadUrlPost = <ThrowOnError extends boolean = false>(options: Options<BugReportAttachmentUploadUrlApiBugReportAttachmentsUploadUrlPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BugReportAttachmentUploadUrlApiBugReportAttachmentsUploadUrlPostResponse, BugReportAttachmentUploadUrlApiBugReportAttachmentsUploadUrlPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/bug-report/attachments/upload-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Complete Google Calendar Connection
 */
export const completeGoogleCalendarConnection = <ThrowOnError extends boolean = false>(options?: Options<CompleteGoogleCalendarConnectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, CompleteGoogleCalendarConnectionError, ThrowOnError>({
        url: '/api/calendar/google/callback',
        ...options
    });
};

/**
 * Start Google Calendar Connection
 */
export const startGoogleCalendarConnection = <ThrowOnError extends boolean = false>(options?: Options<StartGoogleCalendarConnectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/calendar/google/start',
        ...options
    });
};

/**
 * Read Garment For Edit
 */
export const readGarmentForEditApiGarmentsGarmentIdEditGet = <ThrowOnError extends boolean = false>(options: Options<ReadGarmentForEditApiGarmentsGarmentIdEditGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReadGarmentForEditApiGarmentsGarmentIdEditGetResponse, ReadGarmentForEditApiGarmentsGarmentIdEditGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/garments/{garment_id}/edit',
        ...options
    });
};

/**
 * Edit Garment Tags
 */
export const editGarmentTagsApiGarmentsGarmentIdTagsPost = <ThrowOnError extends boolean = false>(options: Options<EditGarmentTagsApiGarmentsGarmentIdTagsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EditGarmentTagsApiGarmentsGarmentIdTagsPostResponse, EditGarmentTagsApiGarmentsGarmentIdTagsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/garments/{garment_id}/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Accept Legal
 */
export const acceptLegalApiMembersMeAcceptLegalPost = <ThrowOnError extends boolean = false>(options: Options<AcceptLegalApiMembersMeAcceptLegalPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/members/me/accept-legal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Profile
 */
export const deleteProfileApiMembersMeDeletePost = <ThrowOnError extends boolean = false>(options?: Options<DeleteProfileApiMembersMeDeletePostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/members/me/delete',
        ...options
    });
};

/**
 * Personal
 */
export const personalApiMembersMePersonalPost = <ThrowOnError extends boolean = false>(options: Options<PersonalApiMembersMePersonalPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        ...urlSearchParamsBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/members/me/personal',
        ...options,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options?.headers
        }
    });
};

/**
 * Preferences
 */
export const preferencesApiMembersMePreferencesPost = <ThrowOnError extends boolean = false>(options: Options<PreferencesApiMembersMePreferencesPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        ...urlSearchParamsBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/members/me/preferences',
        ...options,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options?.headers
        }
    });
};

/**
 * Presentation
 */
export const presentationApiMembersMePresentationPost = <ThrowOnError extends boolean = false>(options: Options<PresentationApiMembersMePresentationPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/members/me/presentation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Privacy
 */
export const privacyApiMembersMePrivacyPost = <ThrowOnError extends boolean = false>(options: Options<PrivacyApiMembersMePrivacyPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        ...urlSearchParamsBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/members/me/privacy',
        ...options,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options?.headers
        }
    });
};

/**
 * Measurements
 */
export const measurementsApiMembersMeProfilePost = <ThrowOnError extends boolean = false>(options: Options<MeasurementsApiMembersMeProfilePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/members/me/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Studio Conversation Feedback
 */
export const consumerStudioChatFeedback = <ThrowOnError extends boolean = false>(options: Options<ConsumerStudioChatFeedbackData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, ConsumerStudioChatFeedbackError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/studio/conversation/feedback',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Change the authenticated principal password
 */
export const changePasswordApiV1AuthChangePasswordPost = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordApiV1AuthChangePasswordPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangePasswordApiV1AuthChangePasswordPostResponse, ChangePasswordApiV1AuthChangePasswordPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/change-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Request password reset
 */
export const forgotPasswordApiV1AuthForgotPasswordPost = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordApiV1AuthForgotPasswordPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ForgotPasswordApiV1AuthForgotPasswordPostResponse, ForgotPasswordApiV1AuthForgotPasswordPostError, ThrowOnError>({
        url: '/api/v1/auth/forgot-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Sign in a member
 */
export const loginApiV1AuthLoginPost = <ThrowOnError extends boolean = false>(options: Options<LoginApiV1AuthLoginPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LoginApiV1AuthLoginPostResponse, LoginApiV1AuthLoginPostError, ThrowOnError>({
        url: '/api/v1/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * End a member session
 */
export const logoutApiV1AuthLogoutPost = <ThrowOnError extends boolean = false>(options: Options<LogoutApiV1AuthLogoutPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LogoutApiV1AuthLogoutPostResponse, LogoutApiV1AuthLogoutPostError, ThrowOnError>({
        url: '/api/v1/auth/logout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Rotate a refresh token
 */
export const refreshApiV1AuthRefreshPost = <ThrowOnError extends boolean = false>(options: Options<RefreshApiV1AuthRefreshPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RefreshApiV1AuthRefreshPostResponse, RefreshApiV1AuthRefreshPostError, ThrowOnError>({
        url: '/api/v1/auth/refresh',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reset member password
 */
export const resetPasswordApiV1AuthResetPasswordPost = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordApiV1AuthResetPasswordPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResetPasswordApiV1AuthResetPasswordPostResponse, ResetPasswordApiV1AuthResetPasswordPostError, ThrowOnError>({
        url: '/api/v1/auth/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Database
 */
export const databaseApiV1DatabaseGet = <ThrowOnError extends boolean = false>(options?: Options<DatabaseApiV1DatabaseGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DatabaseApiV1DatabaseGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/database',
        ...options
    });
};

/**
 * Health
 */
export const healthApiV1HealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthApiV1HealthGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthApiV1HealthGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/health',
        ...options
    });
};

/**
 * Account Deletions
 */
export const accountDeletionsApiV1InternalAccountDeletionsGet = <ThrowOnError extends boolean = false>(options?: Options<AccountDeletionsApiV1InternalAccountDeletionsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AccountDeletionsApiV1InternalAccountDeletionsGetResponse, AccountDeletionsApiV1InternalAccountDeletionsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/account-deletions',
        ...options
    });
};

/**
 * Account Deletion
 */
export const accountDeletionApiV1InternalAccountDeletionsRequestIdGet = <ThrowOnError extends boolean = false>(options: Options<AccountDeletionApiV1InternalAccountDeletionsRequestIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AccountDeletionApiV1InternalAccountDeletionsRequestIdGetResponse, AccountDeletionApiV1InternalAccountDeletionsRequestIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/account-deletions/{request_id}',
        ...options
    });
};

/**
 * Retry Account Deletion
 */
export const retryAccountDeletionApiV1InternalAccountDeletionsRequestIdRetryPost = <ThrowOnError extends boolean = false>(options: Options<RetryAccountDeletionApiV1InternalAccountDeletionsRequestIdRetryPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetryAccountDeletionApiV1InternalAccountDeletionsRequestIdRetryPostResponse, RetryAccountDeletionApiV1InternalAccountDeletionsRequestIdRetryPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/account-deletions/{request_id}/retry',
        ...options
    });
};

/**
 * Accounts
 */
export const accountsApiV1InternalAccountsGet = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiV1InternalAccountsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AccountsApiV1InternalAccountsGetResponse, AccountsApiV1InternalAccountsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/accounts',
        ...options
    });
};

/**
 * Create Accounts Batch
 */
export const createAccountsBatchApiV1InternalAccountsBatchPost = <ThrowOnError extends boolean = false>(options: Options<CreateAccountsBatchApiV1InternalAccountsBatchPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateAccountsBatchApiV1InternalAccountsBatchPostResponse, CreateAccountsBatchApiV1InternalAccountsBatchPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/accounts/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Manage Account
 */
export const manageAccountApiV1InternalAccountsIdPatch = <ThrowOnError extends boolean = false>(options: Options<ManageAccountApiV1InternalAccountsIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ManageAccountApiV1InternalAccountsIdPatchResponse, ManageAccountApiV1InternalAccountsIdPatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/accounts/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Issue Password Reset Link
 * Mint a recovery link and return it, instead of emailing the member.
 *
 * `PATCH /accounts/{id}` with `resend: "reset"` already emails one. This is
 * the other half of the same choice: the operator is handed the URL and
 * passes it on through whatever channel they already have the member on,
 * which is the only thing that works when the broken mailbox is the reason
 * they need a reset.
 *
 * Minting a link into a staff account is a different act from minting one
 * into a member's - it is a way to take over an account that can manage
 * other accounts - so the target's role, not the route, decides how much
 * permission it costs.
 */
export const issuePasswordResetLinkApiV1InternalAccountsIdPasswordResetLinkPost = <ThrowOnError extends boolean = false>(options: Options<IssuePasswordResetLinkApiV1InternalAccountsIdPasswordResetLinkPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IssuePasswordResetLinkApiV1InternalAccountsIdPasswordResetLinkPostResponse, IssuePasswordResetLinkApiV1InternalAccountsIdPasswordResetLinkPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/accounts/{id}/password-reset-link',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Activity Logs
 */
export const activityLogsApiV1InternalActivityLogsGet = <ThrowOnError extends boolean = false>(options?: Options<ActivityLogsApiV1InternalActivityLogsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ActivityLogsApiV1InternalActivityLogsGetResponse, ActivityLogsApiV1InternalActivityLogsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/activity-logs',
        ...options
    });
};

/**
 * Ai Costs
 */
export const aiCostsApiV1InternalAiCostsGet = <ThrowOnError extends boolean = false>(options?: Options<AiCostsApiV1InternalAiCostsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCostsApiV1InternalAiCostsGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/ai-costs',
        ...options
    });
};

/**
 * Audit Records
 * Staff actions, newest first: who did what to which record, and the
 * reason they gave. Written by on-behalf writes, usage-limit changes,
 * operator controls and account and access changes.
 */
export const auditRecordsApiV1InternalAuditRecordsGet = <ThrowOnError extends boolean = false>(options?: Options<AuditRecordsApiV1InternalAuditRecordsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AuditRecordsApiV1InternalAuditRecordsGetResponse, AuditRecordsApiV1InternalAuditRecordsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/audit-records',
        ...options
    });
};

/**
 * Usage Limit Defaults
 * The fleet-wide fallback, read separately from any one member.
 */
export const usageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsGet = <ThrowOnError extends boolean = false>(options?: Options<UsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/configuration/usage-limit-defaults',
        ...options
    });
};

/**
 * Set Usage Limit Defaults
 * Change what applies once a member has no override and no plan entitlement.
 *
 * This is the bottom of the resolution chain the read already documents:
 * per-member override, then plan entitlement, then this, then the
 * hardcoded code default. Changing it moves every member who is not
 * individually overridden and not on a plan that pins the key.
 */
export const setUsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsPut = <ThrowOnError extends boolean = false>(options: Options<SetUsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetUsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsPutResponse, SetUsageLimitDefaultsApiV1InternalConfigurationUsageLimitDefaultsPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/configuration/usage-limit-defaults',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Control
 */
export const controlApiV1InternalControlsPost = <ThrowOnError extends boolean = false>(options: Options<ControlApiV1InternalControlsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ControlApiV1InternalControlsPostResponse, ControlApiV1InternalControlsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/controls',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Dashboard
 */
export const dashboardApiV1InternalDashboardGet = <ThrowOnError extends boolean = false>(options?: Options<DashboardApiV1InternalDashboardGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardApiV1InternalDashboardGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/dashboard',
        ...options
    });
};

/**
 * Deletion Requests
 */
export const deletionRequestsApiV1InternalDeletionRequestsGet = <ThrowOnError extends boolean = false>(options?: Options<DeletionRequestsApiV1InternalDeletionRequestsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DeletionRequestsApiV1InternalDeletionRequestsGetResponse, DeletionRequestsApiV1InternalDeletionRequestsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/deletion-requests',
        ...options
    });
};

/**
 * Restore Deletion Request
 * Reverse a soft delete as an explicit operator act.
 *
 * Restoration is never implicit - undeleting because a member signed in would
 * override a deliberate deletion inside its grace window. A second attempt
 * returns 409 rather than silently succeeding, so a double submit cannot look
 * like it acted twice.
 */
export const restoreDeletionRequestApiV1InternalDeletionRequestsRequestIdRestorePost = <ThrowOnError extends boolean = false>(options: Options<RestoreDeletionRequestApiV1InternalDeletionRequestsRequestIdRestorePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RestoreDeletionRequestApiV1InternalDeletionRequestsRequestIdRestorePostResponse, RestoreDeletionRequestApiV1InternalDeletionRequestsRequestIdRestorePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/deletion-requests/{request_id}/restore',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Email Deliveries
 */
export const emailDeliveriesApiV1InternalEmailDeliveriesGet = <ThrowOnError extends boolean = false>(options?: Options<EmailDeliveriesApiV1InternalEmailDeliveriesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<EmailDeliveriesApiV1InternalEmailDeliveriesGetResponse, EmailDeliveriesApiV1InternalEmailDeliveriesGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/email-deliveries',
        ...options
    });
};

/**
 * Feature Flags
 * Every flag the code declares, with the state that applies now and where it comes
 * from: the stored row (`source: "stored"`) or the code default (`source: "default"`).
 * A flag nobody has set yet is listed with its default. A change made with
 * `PUT /feature-flags/{key}` reaches every process within `cache_ttl_seconds`. Each
 * change's audit record is at
 * `GET /audit-records?resource_type=feature_flag&resource_id={key}`.
 */
export const featureFlagsApiV1InternalFeatureFlagsGet = <ThrowOnError extends boolean = false>(options?: Options<FeatureFlagsApiV1InternalFeatureFlagsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<FeatureFlagsApiV1InternalFeatureFlagsGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/feature-flags',
        ...options
    });
};

/**
 * Reset Feature Flag
 * Delete one flag's stored row, so its code default applies again.
 *
 * Writes one audit record (the stored state before, null after). A flag with no stored row
 * is already at its default: the answer is the same and nothing is written. 404 for a key
 * the code does not declare.
 */
export const resetFeatureFlagApiV1InternalFeatureFlagsKeyDelete = <ThrowOnError extends boolean = false>(options: Options<ResetFeatureFlagApiV1InternalFeatureFlagsKeyDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ResetFeatureFlagApiV1InternalFeatureFlagsKeyDeleteResponse, ResetFeatureFlagApiV1InternalFeatureFlagsKeyDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/feature-flags/{key}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Set Feature Flag
 * Store one flag's state and write one audit record with the reason, before and after.
 *
 * 404 for a key the code does not declare: a flag nothing reads cannot be set.
 */
export const setFeatureFlagApiV1InternalFeatureFlagsKeyPut = <ThrowOnError extends boolean = false>(options: Options<SetFeatureFlagApiV1InternalFeatureFlagsKeyPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetFeatureFlagApiV1InternalFeatureFlagsKeyPutResponse, SetFeatureFlagApiV1InternalFeatureFlagsKeyPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/feature-flags/{key}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Feedback
 * Every member's feedback, newest first: bug reports, chat reply votes, outfit
 * feedback, recommendation feedback and members' garment-set reviews. A verdict a
 * member changed appears once, as their latest. With `status`, only the bug reports in
 * those statuses. A bug report's `attachments` carry URLs signed for 15 minutes.
 */
export const memberFeedbackApiV1InternalFeedbackGet = <ThrowOnError extends boolean = false>(options?: Options<MemberFeedbackApiV1InternalFeedbackGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberFeedbackApiV1InternalFeedbackGetResponse, MemberFeedbackApiV1InternalFeedbackGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/feedback',
        ...options
    });
};

/**
 * Triage Bug Report
 * Set a bug report's status, and replace its note when `note` is sent (blank clears it).
 * Records who and when as `triaged_by` and `triaged_at`, and writes one audit record
 * (`resource_type=bug_report`) with the status and note before and after. 404 for an
 * unknown report.
 */
export const triageBugReportApiV1InternalFeedbackBugReportsReportIdPatch = <ThrowOnError extends boolean = false>(options: Options<TriageBugReportApiV1InternalFeedbackBugReportsReportIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<TriageBugReportApiV1InternalFeedbackBugReportsReportIdPatchResponse, TriageBugReportApiV1InternalFeedbackBugReportsReportIdPatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/feedback/bug-reports/{report_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Failed Garments
 */
export const failedGarmentsApiV1InternalGarmentsFailedGet = <ThrowOnError extends boolean = false>(options?: Options<FailedGarmentsApiV1InternalGarmentsFailedGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<FailedGarmentsApiV1InternalGarmentsFailedGetResponse, FailedGarmentsApiV1InternalGarmentsFailedGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/garments/failed',
        ...options
    });
};

/**
 * Health
 */
export const healthApiV1InternalHealthDashboardGet = <ThrowOnError extends boolean = false>(options?: Options<HealthApiV1InternalHealthDashboardGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthApiV1InternalHealthDashboardGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/health-dashboard',
        ...options
    });
};

/**
 * Landing Stats
 */
export const landingStatsApiV1InternalLandingStatsGet = <ThrowOnError extends boolean = false>(options?: Options<LandingStatsApiV1InternalLandingStatsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LandingStatsApiV1InternalLandingStatsGetResponse, LandingStatsApiV1InternalLandingStatsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/landing-stats',
        ...options
    });
};

/**
 * List Members
 */
export const listMembersApiV1InternalMembersGet = <ThrowOnError extends boolean = false>(options?: Options<ListMembersApiV1InternalMembersGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMembersApiV1InternalMembersGetResponse, ListMembersApiV1InternalMembersGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/members',
        ...options
    });
};

/**
 * Change Member Access
 */
export const changeMemberAccessApiV1InternalMembersMemberIdAccessPost = <ThrowOnError extends boolean = false>(options: Options<ChangeMemberAccessApiV1InternalMembersMemberIdAccessPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeMemberAccessApiV1InternalMembersMemberIdAccessPostResponse, ChangeMemberAccessApiV1InternalMembersMemberIdAccessPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/members/{member_id}/access',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Metrics
 */
export const metricsApiV1InternalMetricsDashboardGet = <ThrowOnError extends boolean = false>(options?: Options<MetricsApiV1InternalMetricsDashboardGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MetricsApiV1InternalMetricsDashboardGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/metrics-dashboard',
        ...options
    });
};

/**
 * List Api Call Logs
 */
export const listApiCallLogsApiV1InternalObservabilityApiCallLogsGet = <ThrowOnError extends boolean = false>(options?: Options<ListApiCallLogsApiV1InternalObservabilityApiCallLogsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListApiCallLogsApiV1InternalObservabilityApiCallLogsGetResponse, ListApiCallLogsApiV1InternalObservabilityApiCallLogsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/observability/api-call-logs',
        ...options
    });
};

/**
 * Correlation
 */
export const correlationApiV1InternalObservabilityCorrelationsCorrelationIdGet = <ThrowOnError extends boolean = false>(options: Options<CorrelationApiV1InternalObservabilityCorrelationsCorrelationIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CorrelationApiV1InternalObservabilityCorrelationsCorrelationIdGetResponse, CorrelationApiV1InternalObservabilityCorrelationsCorrelationIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/observability/correlations/{correlation_id}',
        ...options
    });
};

/**
 * Log Lines
 */
export const logLinesApiV1InternalObservabilityLogLinesGet = <ThrowOnError extends boolean = false>(options?: Options<LogLinesApiV1InternalObservabilityLogLinesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LogLinesApiV1InternalObservabilityLogLinesGetResponse, LogLinesApiV1InternalObservabilityLogLinesGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/observability/log-lines',
        ...options
    });
};

/**
 * Mobile Telemetry
 * Read what mobile clients reported failing, by release and platform.
 */
export const mobileTelemetryApiV1InternalObservabilityMobileTelemetryGet = <ThrowOnError extends boolean = false>(options?: Options<MobileTelemetryApiV1InternalObservabilityMobileTelemetryGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MobileTelemetryApiV1InternalObservabilityMobileTelemetryGetResponse, MobileTelemetryApiV1InternalObservabilityMobileTelemetryGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/observability/mobile-telemetry',
        ...options
    });
};

/**
 * List Scheduled Onboarding Sessions
 */
export const listScheduledOnboardingSessionsApiV1InternalOnboardingSessionsGet = <ThrowOnError extends boolean = false>(options?: Options<ListScheduledOnboardingSessionsApiV1InternalOnboardingSessionsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListScheduledOnboardingSessionsApiV1InternalOnboardingSessionsGetResponse, ListScheduledOnboardingSessionsApiV1InternalOnboardingSessionsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/onboarding-sessions',
        ...options
    });
};

/**
 * Cancel User Onboarding Session
 */
export const cancelUserOnboardingSessionApiV1InternalOnboardingSessionsIdCancelPost = <ThrowOnError extends boolean = false>(options: Options<CancelUserOnboardingSessionApiV1InternalOnboardingSessionsIdCancelPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelUserOnboardingSessionApiV1InternalOnboardingSessionsIdCancelPostResponse, CancelUserOnboardingSessionApiV1InternalOnboardingSessionsIdCancelPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/onboarding-sessions/{id}/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reschedule User Onboarding Session
 */
export const rescheduleUserOnboardingSessionApiV1InternalOnboardingSessionsIdReschedulePost = <ThrowOnError extends boolean = false>(options: Options<RescheduleUserOnboardingSessionApiV1InternalOnboardingSessionsIdReschedulePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RescheduleUserOnboardingSessionApiV1InternalOnboardingSessionsIdReschedulePostResponse, RescheduleUserOnboardingSessionApiV1InternalOnboardingSessionsIdReschedulePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/onboarding-sessions/{id}/reschedule',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List Jobs
 * One row per job, newest first. `before` pages by job id for a stable
 * keyset cursor (created_at is not unique enough alone under load).
 * `member_id` keeps one member's runs, served by `ix_fastapi_worker_jobs_member`.
 */
export const listJobsApiV1InternalOperatorWorkflowJobsJobsGet = <ThrowOnError extends boolean = false>(options?: Options<ListJobsApiV1InternalOperatorWorkflowJobsJobsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListJobsApiV1InternalOperatorWorkflowJobsJobsGetResponse, ListJobsApiV1InternalOperatorWorkflowJobsJobsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/operator/workflow-jobs/jobs',
        ...options
    });
};

/**
 * Get Job
 * Job detail plus its step progress: the latest `workflow.step_progress`
 * checkpoint carries the accumulated `completed` step results and `logs`
 * for every step in the run (see `app.runtime.workflow.WorkflowRun`).
 *
 * Each entry in `checkpoints` additionally carries the step's own recorded
 * `inputs` and `outputs` (denylist-redacted and byte-capped when written -
 * see `app.runtime.checkpoint_io`) alongside its `output_references`.
 *
 * `inputs`/`outputs` are `null` for any checkpoint written before step I/O
 * recording existed, or by a handler that supplies none - "not recorded for
 * this run". That is deliberately distinct from `{}`, which means the step
 * recorded its I/O and genuinely had none. Historical rows are not
 * backfilled, so the console must render those two differently.
 *
 * `pipeline_stages` contains garment stage attempts correlated by the writer's
 * `worker_job_id`, with input/output media signed for 900 seconds. Discovery
 * is bounded per stage to depth 8, 32 refs, and 2,048 values. Empty media is [].
 * Source reference blobs are not copied into this new projection.
 *
 * `events` is the job's lifecycle timeline from `fastapi_worker_job_events`
 * (enqueued, claimed, progress with `progress_current`/`progress_total` and a
 * stage `code`, dead_lettered with its `code` and `reference_id`, ...): the
 * newest 200, returned in ascending `sequence`. A plain durable job that
 * writes no checkpoints still has a timeline. The event `details` JSON is omitted.
 *
 * Additive only: no existing field changed name or shape.
 */
export const getJobApiV1InternalOperatorWorkflowJobsJobsJobIdGet = <ThrowOnError extends boolean = false>(options: Options<GetJobApiV1InternalOperatorWorkflowJobsJobsJobIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJobApiV1InternalOperatorWorkflowJobsJobsJobIdGetResponse, GetJobApiV1InternalOperatorWorkflowJobsJobsJobIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/operator/workflow-jobs/jobs/{job_id}',
        ...options
    });
};

/**
 * Cancel Job
 * Cancel a job. Immediate for a queued/retry-wait job; for a running
 * job this only requests cancellation - the running worker observes it
 * and finishes the job as cancelled on its own.
 */
export const cancelJobApiV1InternalOperatorWorkflowJobsJobsJobIdCancelPost = <ThrowOnError extends boolean = false>(options: Options<CancelJobApiV1InternalOperatorWorkflowJobsJobsJobIdCancelPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelJobApiV1InternalOperatorWorkflowJobsJobsJobIdCancelPostResponse, CancelJobApiV1InternalOperatorWorkflowJobsJobsJobIdCancelPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/operator/workflow-jobs/jobs/{job_id}/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Checkpoint Media
 * Stream the image one of this job's own references points at, for an
 * operator preview.
 *
 * Deliberately NOT a signed URL. These references point at member wardrobe
 * photos and generated twin images; a presigned URL is a bearer capability
 * that keeps working from anywhere until it expires, including once it has
 * been pasted into a ticket or a chat. The console sits behind Cloudflare
 * Access and an operator role, and the image must not escape that boundary,
 * so the bytes are proxied and the URL never leaves this process.
 *
 * The security-critical part is the ownership check below. Without it this
 * endpoint is an arbitrary object-storage read oracle for anyone holding the
 * internal service token: pass any key, get any object. So the reference is
 * never taken from the caller as a storage key - it is only honoured when it
 * appears verbatim as a value in *this* job's own payload, or in the
 * `inputs`, `outputs` or `output_references` of one of its checkpoint rows.
 * A reference that belongs to a different job, or to no job at all, is
 * refused with 404 and never reaches storage. Only once ownership holds is a
 * signed URL reduced to its key or a logical asset id resolved, so neither
 * form can smuggle in a key the job does not hold.
 */
export const getCheckpointMediaApiV1InternalOperatorWorkflowJobsJobsJobIdCheckpointMediaGet = <ThrowOnError extends boolean = false>(options: Options<GetCheckpointMediaApiV1InternalOperatorWorkflowJobsJobsJobIdCheckpointMediaGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, GetCheckpointMediaApiV1InternalOperatorWorkflowJobsJobsJobIdCheckpointMediaGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/operator/workflow-jobs/jobs/{job_id}/checkpoint-media',
        ...options
    });
};

/**
 * Resume Job
 * Redrive a job an operator cancelled. Rejects any other status - use
 * /retry for a dead-lettered job instead.
 */
export const resumeJobApiV1InternalOperatorWorkflowJobsJobsJobIdResumePost = <ThrowOnError extends boolean = false>(options: Options<ResumeJobApiV1InternalOperatorWorkflowJobsJobsJobIdResumePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResumeJobApiV1InternalOperatorWorkflowJobsJobsJobIdResumePostResponse, ResumeJobApiV1InternalOperatorWorkflowJobsJobsJobIdResumePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/operator/workflow-jobs/jobs/{job_id}/resume',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retry Job
 * Redrive a dead-lettered job. Rejects any other status - use /resume
 * for a cancelled job instead.
 */
export const retryJobApiV1InternalOperatorWorkflowJobsJobsJobIdRetryPost = <ThrowOnError extends boolean = false>(options: Options<RetryJobApiV1InternalOperatorWorkflowJobsJobsJobIdRetryPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetryJobApiV1InternalOperatorWorkflowJobsJobsJobIdRetryPostResponse, RetryJobApiV1InternalOperatorWorkflowJobsJobsJobIdRetryPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/operator/workflow-jobs/jobs/{job_id}/retry',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List Workflow Families
 * Every family with at least one real job row, for the Jobs screen's
 * sidebar.
 *
 * Deliberately NOT `app.runtime.workflow.discover_workflows()`/`REGISTRY`:
 * every workflow added via the builder pattern (`build_X_workflow(deps, *,
 * family=...)`) only self-registers with `@workflow` when the builder is
 * actually CALLED with real dependencies - which only happens inside
 * `app.runtime.job_registry`'s handler factories at real worker startup, not
 * on module import. Calling those factories here to populate the registry
 * would require this API process to hold full worker credentials
 * (`create_convergence_durable_job_handlers` raises without a real
 * `REPLICATE_API_KEY`, for instance) just to answer "what families exist" -
 * a real credential-scope violation for a read-only reporting endpoint.
 * Reading distinct `kind` values out of real job history has no such
 * dependency and reflects what has actually run, not just what's coded.
 */
export const listWorkflowFamiliesApiV1InternalOperatorWorkflowJobsWorkflowsGet = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowFamiliesApiV1InternalOperatorWorkflowJobsWorkflowsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListWorkflowFamiliesApiV1InternalOperatorWorkflowJobsWorkflowsGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/operator/workflow-jobs/workflows',
        ...options
    });
};

/**
 * Pilot Controls
 */
export const pilotControlsApiV1InternalPilotControlsGet = <ThrowOnError extends boolean = false>(options?: Options<PilotControlsApiV1InternalPilotControlsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PilotControlsApiV1InternalPilotControlsGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/pilot-controls',
        ...options
    });
};

/**
 * Resolve References
 * Labels, a secondary line and a signed image for up to 200 ids of mixed kinds, in one read.
 */
export const resolveReferencesApiV1InternalReferencesResolvePost = <ThrowOnError extends boolean = false>(options: Options<ResolveReferencesApiV1InternalReferencesResolvePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResolveReferencesApiV1InternalReferencesResolvePostResponse, ResolveReferencesApiV1InternalReferencesResolvePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/references/resolve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Scheduling Options
 */
export const getSchedulingOptionsApiV1InternalSchedulingOptionsGet = <ThrowOnError extends boolean = false>(options?: Options<GetSchedulingOptionsApiV1InternalSchedulingOptionsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSchedulingOptionsApiV1InternalSchedulingOptionsGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/scheduling/options',
        ...options
    });
};

/**
 * Recent Searches
 */
export const recentSearchesApiV1InternalSearchesRecentGet = <ThrowOnError extends boolean = false>(options?: Options<RecentSearchesApiV1InternalSearchesRecentGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RecentSearchesApiV1InternalSearchesRecentGetResponse, RecentSearchesApiV1InternalSearchesRecentGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/searches/recent',
        ...options
    });
};

/**
 * Provision Staging Smoke Principals
 */
export const provisionStagingSmokePrincipalsApiV1InternalStagingSmokePrincipalsPost = <ThrowOnError extends boolean = false>(options: Options<ProvisionStagingSmokePrincipalsApiV1InternalStagingSmokePrincipalsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProvisionStagingSmokePrincipalsApiV1InternalStagingSmokePrincipalsPostResponse, ProvisionStagingSmokePrincipalsApiV1InternalStagingSmokePrincipalsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/staging-smoke/principals',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Pair
 */
export const pairApiV1InternalStylistHierarchyPairingsPost = <ThrowOnError extends boolean = false>(options: Options<PairApiV1InternalStylistHierarchyPairingsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PairApiV1InternalStylistHierarchyPairingsPostResponse, PairApiV1InternalStylistHierarchyPairingsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylist-hierarchy/pairings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Set Profile
 */
export const setProfileApiV1InternalStylistHierarchyProfilesStylistIdPut = <ThrowOnError extends boolean = false>(options: Options<SetProfileApiV1InternalStylistHierarchyProfilesStylistIdPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetProfileApiV1InternalStylistHierarchyProfilesStylistIdPutResponse, SetProfileApiV1InternalStylistHierarchyProfilesStylistIdPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylist-hierarchy/profiles/{stylist_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Roster
 */
export const rosterApiV1InternalStylistHierarchyRosterGet = <ThrowOnError extends boolean = false>(options?: Options<RosterApiV1InternalStylistHierarchyRosterGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RosterApiV1InternalStylistHierarchyRosterGetResponse, RosterApiV1InternalStylistHierarchyRosterGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylist-hierarchy/roster',
        ...options
    });
};

/**
 * Routing Rules
 */
export const routingRulesApiV1InternalStylistHierarchyRoutingRulesGet = <ThrowOnError extends boolean = false>(options?: Options<RoutingRulesApiV1InternalStylistHierarchyRoutingRulesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RoutingRulesApiV1InternalStylistHierarchyRoutingRulesGetResponse, RoutingRulesApiV1InternalStylistHierarchyRoutingRulesGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylist-hierarchy/routing-rules',
        ...options
    });
};

/**
 * Write Rule
 */
export const writeRuleApiV1InternalStylistHierarchyRoutingRulesSourceTypePut = <ThrowOnError extends boolean = false>(options: Options<WriteRuleApiV1InternalStylistHierarchyRoutingRulesSourceTypePutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<WriteRuleApiV1InternalStylistHierarchyRoutingRulesSourceTypePutResponse, WriteRuleApiV1InternalStylistHierarchyRoutingRulesSourceTypePutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylist-hierarchy/routing-rules/{source_type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Admin Tasks
 */
export const adminTasksApiV1InternalStylistHierarchyTasksGet = <ThrowOnError extends boolean = false>(options?: Options<AdminTasksApiV1InternalStylistHierarchyTasksGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminTasksApiV1InternalStylistHierarchyTasksGetResponse, AdminTasksApiV1InternalStylistHierarchyTasksGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylist-hierarchy/tasks',
        ...options
    });
};

/**
 * Create Task
 */
export const createTaskApiV1InternalStylistHierarchyTasksPost = <ThrowOnError extends boolean = false>(options: Options<CreateTaskApiV1InternalStylistHierarchyTasksPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTaskApiV1InternalStylistHierarchyTasksPostResponse, CreateTaskApiV1InternalStylistHierarchyTasksPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylist-hierarchy/tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reassign
 */
export const reassignApiV1InternalStylistHierarchyTasksTaskIdReassignPost = <ThrowOnError extends boolean = false>(options: Options<ReassignApiV1InternalStylistHierarchyTasksTaskIdReassignPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReassignApiV1InternalStylistHierarchyTasksTaskIdReassignPostResponse, ReassignApiV1InternalStylistHierarchyTasksTaskIdReassignPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylist-hierarchy/tasks/{task_id}/reassign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List Stylists
 */
export const listStylistsApiV1InternalStylistsGet = <ThrowOnError extends boolean = false>(options?: Options<ListStylistsApiV1InternalStylistsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListStylistsApiV1InternalStylistsGetResponse, ListStylistsApiV1InternalStylistsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylists',
        ...options
    });
};

/**
 * Create Stylist
 */
export const createStylistApiV1InternalStylistsPost = <ThrowOnError extends boolean = false>(options: Options<CreateStylistApiV1InternalStylistsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateStylistApiV1InternalStylistsPostResponse, CreateStylistApiV1InternalStylistsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylists',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List Available Stylists
 */
export const listAvailableStylistsApiV1InternalStylistsAvailableGet = <ThrowOnError extends boolean = false>(options: Options<ListAvailableStylistsApiV1InternalStylistsAvailableGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListAvailableStylistsApiV1InternalStylistsAvailableGetResponse, ListAvailableStylistsApiV1InternalStylistsAvailableGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylists/available',
        ...options
    });
};

/**
 * Get Stylist
 */
export const getStylistApiV1InternalStylistsIdGet = <ThrowOnError extends boolean = false>(options: Options<GetStylistApiV1InternalStylistsIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStylistApiV1InternalStylistsIdGetResponse, GetStylistApiV1InternalStylistsIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylists/{id}',
        ...options
    });
};

/**
 * Update Stylist
 */
export const updateStylistApiV1InternalStylistsIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateStylistApiV1InternalStylistsIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateStylistApiV1InternalStylistsIdPatchResponse, UpdateStylistApiV1InternalStylistsIdPatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylists/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List Stylist Members
 */
export const listStylistMembersApiV1InternalStylistsIdMembersGet = <ThrowOnError extends boolean = false>(options: Options<ListStylistMembersApiV1InternalStylistsIdMembersGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStylistMembersApiV1InternalStylistsIdMembersGetResponse, ListStylistMembersApiV1InternalStylistsIdMembersGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylists/{id}/members',
        ...options
    });
};

/**
 * Assign Stylist Members
 */
export const assignStylistMembersApiV1InternalStylistsIdMembersPost = <ThrowOnError extends boolean = false>(options: Options<AssignStylistMembersApiV1InternalStylistsIdMembersPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssignStylistMembersApiV1InternalStylistsIdMembersPostResponse, AssignStylistMembersApiV1InternalStylistsIdMembersPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylists/{id}/members',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Stylist Oversight
 */
export const stylistOversightApiV1InternalStylistsIdOversightGet = <ThrowOnError extends boolean = false>(options: Options<StylistOversightApiV1InternalStylistsIdOversightGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<StylistOversightApiV1InternalStylistsIdOversightGetResponse, StylistOversightApiV1InternalStylistsIdOversightGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/stylists/{id}/oversight',
        ...options
    });
};

/**
 * List Users
 */
export const listUsersApiV1InternalUsersGet = <ThrowOnError extends boolean = false>(options?: Options<ListUsersApiV1InternalUsersGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListUsersApiV1InternalUsersGetResponse, ListUsersApiV1InternalUsersGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users',
        ...options
    });
};

/**
 * Create User
 */
export const createUserApiV1InternalUsersPost = <ThrowOnError extends boolean = false>(options: Options<CreateUserApiV1InternalUsersPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateUserApiV1InternalUsersPostResponse, CreateUserApiV1InternalUsersPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get User
 */
export const getUserApiV1InternalUsersIdGet = <ThrowOnError extends boolean = false>(options: Options<GetUserApiV1InternalUsersIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUserApiV1InternalUsersIdGetResponse, GetUserApiV1InternalUsersIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}',
        ...options
    });
};

/**
 * Update User
 */
export const updateUserApiV1InternalUsersIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateUserApiV1InternalUsersIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateUserApiV1InternalUsersIdPatchResponse, UpdateUserApiV1InternalUsersIdPatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enhance Member Avatar
 * Queue the member's twin enhancement, at the operator's request.
 *
 * `Idempotency-Key` is required, not optional, for the same reason it is on
 * the batch account create: this is paid GPU work, and an operator whose
 * first click appeared to do nothing will click again. With the key the
 * second request returns the first operation; without one it would buy a
 * second render of the same avatar.
 *
 * The member's daily avatar allowance is untouched - it is claimed in their
 * own generate route, never in the enhancement primitive this borrows - and
 * the audit row says so rather than leaving it to be inferred.
 */
export const enhanceMemberAvatarApiV1InternalUsersIdAvatarEnhancePost = <ThrowOnError extends boolean = false>(options: Options<EnhanceMemberAvatarApiV1InternalUsersIdAvatarEnhancePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EnhanceMemberAvatarApiV1InternalUsersIdAvatarEnhancePostResponse, EnhanceMemberAvatarApiV1InternalUsersIdAvatarEnhancePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/avatar/enhance',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Undo Member Avatar Improvement
 * Put back the predecessor of the member's latest published face edit.
 */
export const undoMemberAvatarImprovementApiV1InternalUsersIdAvatarUndoPost = <ThrowOnError extends boolean = false>(options: Options<UndoMemberAvatarImprovementApiV1InternalUsersIdAvatarUndoPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UndoMemberAvatarImprovementApiV1InternalUsersIdAvatarUndoPostResponse, UndoMemberAvatarImprovementApiV1InternalUsersIdAvatarUndoPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/avatar/undo',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Recompute Member Body Shape
 * Re-derive the member's body shape from the measurements already stored.
 *
 * Not a re-scan, and the name is narrow on purpose. The scan itself comes
 * from the provider with a capture the member has to supply; nothing stored
 * can produce a new one. What this re-runs is the classifier over the numbers
 * already on the member, which is worth a control of its own only because the
 * two have not always been written together.
 *
 * A member with no usable measurements is refused rather than given the
 * classifier's missing-data fallback, because a stored shape nobody measured
 * is indistinguishable downstream from a measured one.
 */
export const recomputeMemberBodyShapeApiV1InternalUsersIdBodyShapeRecomputePost = <ThrowOnError extends boolean = false>(options: Options<RecomputeMemberBodyShapeApiV1InternalUsersIdBodyShapeRecomputePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecomputeMemberBodyShapeApiV1InternalUsersIdBodyShapeRecomputePostResponse, RecomputeMemberBodyShapeApiV1InternalUsersIdBodyShapeRecomputePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/body-shape/recompute',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Chat
 */
export const memberChatApiV1InternalUsersIdChatGet = <ThrowOnError extends boolean = false>(options: Options<MemberChatApiV1InternalUsersIdChatGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberChatApiV1InternalUsersIdChatGetResponse, MemberChatApiV1InternalUsersIdChatGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/chat',
        ...options
    });
};

/**
 * Regenerate Member Daily Look
 * Re-run the member's Outfit-of-the-Day, recorded as the operator's ask.
 *
 * 202 rather than 200: the pipeline is a multi-minute LLM-plus-image run, so
 * what this route can honestly report is that the work was queued, not that
 * a look exists. The console polls the member's look for the result, the
 * same way the member's own device does.
 *
 * The `Idempotency-Key` is required, not optional. A forced regeneration
 * deliberately takes a fresh request id so it cannot be collapsed into the
 * pick it is replacing, which means nothing below this point would notice a
 * duplicate: two presses would be two paid pipeline runs.
 */
export const regenerateMemberDailyLookApiV1InternalUsersIdDailyLookRegeneratePost = <ThrowOnError extends boolean = false>(options: Options<RegenerateMemberDailyLookApiV1InternalUsersIdDailyLookRegeneratePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RegenerateMemberDailyLookApiV1InternalUsersIdDailyLookRegeneratePostResponse, RegenerateMemberDailyLookApiV1InternalUsersIdDailyLookRegeneratePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/daily-look/regenerate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Daily Looks
 */
export const memberDailyLooksApiV1InternalUsersIdDailyLooksGet = <ThrowOnError extends boolean = false>(options: Options<MemberDailyLooksApiV1InternalUsersIdDailyLooksGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberDailyLooksApiV1InternalUsersIdDailyLooksGetResponse, MemberDailyLooksApiV1InternalUsersIdDailyLooksGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/daily-looks',
        ...options
    });
};

/**
 * Request Member Data Export
 */
export const requestMemberDataExportApiV1InternalUsersIdDataExportPost = <ThrowOnError extends boolean = false>(options: Options<RequestMemberDataExportApiV1InternalUsersIdDataExportPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RequestMemberDataExportApiV1InternalUsersIdDataExportPostResponse, RequestMemberDataExportApiV1InternalUsersIdDataExportPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/data-export',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Data Export Status
 */
export const memberDataExportStatusApiV1InternalUsersIdDataExportsExportIdGet = <ThrowOnError extends boolean = false>(options: Options<MemberDataExportStatusApiV1InternalUsersIdDataExportsExportIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberDataExportStatusApiV1InternalUsersIdDataExportsExportIdGetResponse, MemberDataExportStatusApiV1InternalUsersIdDataExportsExportIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/data-exports/{export_id}',
        ...options
    });
};

/**
 * Download Member Data Export
 */
export const downloadMemberDataExportApiV1InternalUsersIdDataExportsExportIdDownloadGet = <ThrowOnError extends boolean = false>(options: Options<DownloadMemberDataExportApiV1InternalUsersIdDataExportsExportIdDownloadGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadMemberDataExportApiV1InternalUsersIdDataExportsExportIdDownloadGetResponse, DownloadMemberDataExportApiV1InternalUsersIdDataExportsExportIdDownloadGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/data-exports/{export_id}/download',
        ...options
    });
};

/**
 * Request Member Account Deletion
 */
export const requestMemberAccountDeletionApiV1InternalUsersIdDeletionRequestPost = <ThrowOnError extends boolean = false>(options: Options<RequestMemberAccountDeletionApiV1InternalUsersIdDeletionRequestPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RequestMemberAccountDeletionApiV1InternalUsersIdDeletionRequestPostResponse, RequestMemberAccountDeletionApiV1InternalUsersIdDeletionRequestPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/deletion-request',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Garment Sets
 */
export const memberGarmentSetsApiV1InternalUsersIdGarmentSetsGet = <ThrowOnError extends boolean = false>(options: Options<MemberGarmentSetsApiV1InternalUsersIdGarmentSetsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberGarmentSetsApiV1InternalUsersIdGarmentSetsGetResponse, MemberGarmentSetsApiV1InternalUsersIdGarmentSetsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/garment-sets',
        ...options
    });
};

/**
 * Create Member Garment Set
 */
export const createMemberGarmentSetApiV1InternalUsersIdGarmentSetsPost = <ThrowOnError extends boolean = false>(options: Options<CreateMemberGarmentSetApiV1InternalUsersIdGarmentSetsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMemberGarmentSetApiV1InternalUsersIdGarmentSetsPostResponse, CreateMemberGarmentSetApiV1InternalUsersIdGarmentSetsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/garment-sets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retire Member Garment Set
 */
export const retireMemberGarmentSetApiV1InternalUsersIdGarmentSetsSetIdDelete = <ThrowOnError extends boolean = false>(options: Options<RetireMemberGarmentSetApiV1InternalUsersIdGarmentSetsSetIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RetireMemberGarmentSetApiV1InternalUsersIdGarmentSetsSetIdDeleteResponse, RetireMemberGarmentSetApiV1InternalUsersIdGarmentSetsSetIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/garment-sets/{set_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Create Member Look Folder
 * Alias wardrobe-folder creation; removed once admin uses `/wardrobe-folders`.
 * @deprecated
 */
export const createMemberLookFolderApiV1InternalUsersIdLookFoldersPost = <ThrowOnError extends boolean = false>(options: Options<CreateMemberLookFolderApiV1InternalUsersIdLookFoldersPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMemberLookFolderApiV1InternalUsersIdLookFoldersPostResponse, CreateMemberLookFolderApiV1InternalUsersIdLookFoldersPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/look-folders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Mutate Member Look Folder Membership
 * Alias wardrobe-folder filing; removed once admin uses `/wardrobe-folders`.
 * @deprecated
 */
export const mutateMemberLookFolderMembershipApiV1InternalUsersIdLookFoldersMembershipPost = <ThrowOnError extends boolean = false>(options: Options<MutateMemberLookFolderMembershipApiV1InternalUsersIdLookFoldersMembershipPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MutateMemberLookFolderMembershipApiV1InternalUsersIdLookFoldersMembershipPostResponse, MutateMemberLookFolderMembershipApiV1InternalUsersIdLookFoldersMembershipPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/look-folders/membership',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Read Member Notification Preferences
 * The member's notification settings, or the defaults when none are saved.
 */
export const readMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesGet = <ThrowOnError extends boolean = false>(options: Options<ReadMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReadMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesGetResponse, ReadMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/notification-preferences',
        ...options
    });
};

/**
 * Update Member Notification Preferences
 * Replace the notification preferences stored for a member.
 */
export const updateMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesPut = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesPutResponse, UpdateMemberNotificationPreferencesApiV1InternalUsersIdNotificationPreferencesPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/notification-preferences',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Onboarding
 */
export const memberOnboardingApiV1InternalUsersIdOnboardingGet = <ThrowOnError extends boolean = false>(options: Options<MemberOnboardingApiV1InternalUsersIdOnboardingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberOnboardingApiV1InternalUsersIdOnboardingGetResponse, MemberOnboardingApiV1InternalUsersIdOnboardingGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/onboarding',
        ...options
    });
};

/**
 * Schedule User Onboarding Session
 */
export const scheduleUserOnboardingSessionApiV1InternalUsersIdOnboardingSessionPost = <ThrowOnError extends boolean = false>(options: Options<ScheduleUserOnboardingSessionApiV1InternalUsersIdOnboardingSessionPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ScheduleUserOnboardingSessionApiV1InternalUsersIdOnboardingSessionPostResponse, ScheduleUserOnboardingSessionApiV1InternalUsersIdOnboardingSessionPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/onboarding-session',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Onboarding Answers
 * Read every onboarding answer and capture a member has stored. Read-only.
 */
export const memberOnboardingAnswersApiV1InternalUsersIdOnboardingAnswersGet = <ThrowOnError extends boolean = false>(options: Options<MemberOnboardingAnswersApiV1InternalUsersIdOnboardingAnswersGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberOnboardingAnswersApiV1InternalUsersIdOnboardingAnswersGetResponse, MemberOnboardingAnswersApiV1InternalUsersIdOnboardingAnswersGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/onboarding/answers',
        ...options
    });
};

/**
 * Save Member Onboarding Checkpoint
 */
export const saveMemberOnboardingCheckpointApiV1InternalUsersIdOnboardingCheckpointPut = <ThrowOnError extends boolean = false>(options: Options<SaveMemberOnboardingCheckpointApiV1InternalUsersIdOnboardingCheckpointPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SaveMemberOnboardingCheckpointApiV1InternalUsersIdOnboardingCheckpointPutResponse, SaveMemberOnboardingCheckpointApiV1InternalUsersIdOnboardingCheckpointPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/onboarding/checkpoint',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Complete Member Onboarding
 * Complete onboarding on behalf of the member.
 */
export const completeMemberOnboardingApiV1InternalUsersIdOnboardingCompletePost = <ThrowOnError extends boolean = false>(options: Options<CompleteMemberOnboardingApiV1InternalUsersIdOnboardingCompletePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CompleteMemberOnboardingApiV1InternalUsersIdOnboardingCompletePostResponse, CompleteMemberOnboardingApiV1InternalUsersIdOnboardingCompletePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/onboarding/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Nudge Member Onboarding
 * Queue an onboarding reminder for a member who stalled part way through.
 *
 * Read the response as "a delivery row exists", not as "the member saw
 * something". Nothing in the platform renders a `notification_deliveries`
 * row today - no worker claims the queued ones and no consumer screen reads
 * them - so this ships the backend half deliberately, with the app reading
 * it as a follow-up. An operator promised a nudge that nobody sends would
 * stop chasing the member, which is the one outcome worth avoiding while
 * that half is missing.
 *
 * A second nudge inside 24 hours is refused with a 429 rather than absorbed,
 * and the window covers the automated abandonment reminder too, because the
 * member does not care which of the two senders is talking to them.
 */
export const nudgeMemberOnboardingApiV1InternalUsersIdOnboardingNudgePost = <ThrowOnError extends boolean = false>(options: Options<NudgeMemberOnboardingApiV1InternalUsersIdOnboardingNudgePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<NudgeMemberOnboardingApiV1InternalUsersIdOnboardingNudgePostResponse, NudgeMemberOnboardingApiV1InternalUsersIdOnboardingNudgePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/onboarding/nudge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reset Member Onboarding
 * Reset onboarding state without deleting member artefacts.
 */
export const resetMemberOnboardingApiV1InternalUsersIdOnboardingResetPost = <ThrowOnError extends boolean = false>(options: Options<ResetMemberOnboardingApiV1InternalUsersIdOnboardingResetPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResetMemberOnboardingApiV1InternalUsersIdOnboardingResetPostResponse, ResetMemberOnboardingApiV1InternalUsersIdOnboardingResetPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/onboarding/reset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Outfits
 */
export const memberOutfitsApiV1InternalUsersIdOutfitsGet = <ThrowOnError extends boolean = false>(options: Options<MemberOutfitsApiV1InternalUsersIdOutfitsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberOutfitsApiV1InternalUsersIdOutfitsGetResponse, MemberOutfitsApiV1InternalUsersIdOutfitsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits',
        ...options
    });
};

/**
 * Create Member Outfit
 * Create a composed outfit and enqueue its title job for the member.
 */
export const createMemberOutfitApiV1InternalUsersIdOutfitsPost = <ThrowOnError extends boolean = false>(options: Options<CreateMemberOutfitApiV1InternalUsersIdOutfitsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMemberOutfitApiV1InternalUsersIdOutfitsPostResponse, CreateMemberOutfitApiV1InternalUsersIdOutfitsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Bookmark Member Outfit
 * Set one member outfit's bookmark state as the operator.
 */
export const bookmarkMemberOutfitApiV1InternalUsersIdOutfitsBookmarkPost = <ThrowOnError extends boolean = false>(options: Options<BookmarkMemberOutfitApiV1InternalUsersIdOutfitsBookmarkPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BookmarkMemberOutfitApiV1InternalUsersIdOutfitsBookmarkPostResponse, BookmarkMemberOutfitApiV1InternalUsersIdOutfitsBookmarkPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/bookmark',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Bulk Member Outfits
 * Delete the named outfits, or with `all` the member's oldest 500.
 *
 * Call again with `all` until `remaining` is zero to clear a larger wardrobe.
 */
export const bulkMemberOutfitsApiV1InternalUsersIdOutfitsBulkPost = <ThrowOnError extends boolean = false>(options: Options<BulkMemberOutfitsApiV1InternalUsersIdOutfitsBulkPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BulkMemberOutfitsApiV1InternalUsersIdOutfitsBulkPostResponse, BulkMemberOutfitsApiV1InternalUsersIdOutfitsBulkPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Regenerate Member Outfit
 * Regenerate one of the member's outfits without spending their allowance.
 *
 * The member's own regeneration claims a daily attempt; this one does not,
 * because an operator fixing something broken must not charge the member for
 * the fix. That is the single behavioural difference between this route and
 * the member's - everything else is the same service call.
 */
export const regenerateMemberOutfitApiV1InternalUsersIdOutfitsRegeneratePost = <ThrowOnError extends boolean = false>(options: Options<RegenerateMemberOutfitApiV1InternalUsersIdOutfitsRegeneratePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RegenerateMemberOutfitApiV1InternalUsersIdOutfitsRegeneratePostResponse, RegenerateMemberOutfitApiV1InternalUsersIdOutfitsRegeneratePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/regenerate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Mark Member Outfit Worn
 * Record wear state and optional feedback for one member outfit.
 */
export const markMemberOutfitWornApiV1InternalUsersIdOutfitsWearPost = <ThrowOnError extends boolean = false>(options: Options<MarkMemberOutfitWornApiV1InternalUsersIdOutfitsWearPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MarkMemberOutfitWornApiV1InternalUsersIdOutfitsWearPostResponse, MarkMemberOutfitWornApiV1InternalUsersIdOutfitsWearPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/wear',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Member Outfit
 * Hard-delete one of the member's outfits, with everything that depends on it.
 *
 * An OOTD or styling outfit leaves the member's OOTD too; its render image is
 * deleted once no other outfit, render or saved look still uses it.
 */
export const deleteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdDeleteResponse, DeleteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/{outfit_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Outfit
 */
export const memberOutfitApiV1InternalUsersIdOutfitsOutfitIdGet = <ThrowOnError extends boolean = false>(options: Options<MemberOutfitApiV1InternalUsersIdOutfitsOutfitIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberOutfitApiV1InternalUsersIdOutfitsOutfitIdGetResponse, MemberOutfitApiV1InternalUsersIdOutfitsOutfitIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/{outfit_id}',
        ...options
    });
};

/**
 * Set Member Outfit Garments
 * Replace the garments and composer metadata on one member outfit.
 */
export const setMemberOutfitGarmentsApiV1InternalUsersIdOutfitsOutfitIdGarmentsPost = <ThrowOnError extends boolean = false>(options: Options<SetMemberOutfitGarmentsApiV1InternalUsersIdOutfitsOutfitIdGarmentsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SetMemberOutfitGarmentsApiV1InternalUsersIdOutfitsOutfitIdGarmentsPostResponse, SetMemberOutfitGarmentsApiV1InternalUsersIdOutfitsOutfitIdGarmentsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/{outfit_id}/garments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Promote Member Outfit
 * Promote one member outfit without the consumer route's redirect plumbing.
 */
export const promoteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdPromotePost = <ThrowOnError extends boolean = false>(options: Options<PromoteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdPromotePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PromoteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdPromotePostResponse, PromoteMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdPromotePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/{outfit_id}/promote',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Edit Member Outfit Tags
 * Edit the member's outfit tags through the consumer service.
 */
export const editMemberOutfitTagsApiV1InternalUsersIdOutfitsOutfitIdTagsPatch = <ThrowOnError extends boolean = false>(options: Options<EditMemberOutfitTagsApiV1InternalUsersIdOutfitsOutfitIdTagsPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<EditMemberOutfitTagsApiV1InternalUsersIdOutfitsOutfitIdTagsPatchResponse, EditMemberOutfitTagsApiV1InternalUsersIdOutfitsOutfitIdTagsPatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/{outfit_id}/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Rename Member Outfit
 * Rename an owned outfit after reading its current revision server-side.
 */
export const renameMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdTitlePatch = <ThrowOnError extends boolean = false>(options: Options<RenameMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdTitlePatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<RenameMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdTitlePatchResponse, RenameMemberOutfitApiV1InternalUsersIdOutfitsOutfitIdTitlePatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/outfits/{outfit_id}/title',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Set Member Profile Location
 */
export const setMemberProfileLocationApiV1InternalUsersIdProfileLocationPut = <ThrowOnError extends boolean = false>(options: Options<SetMemberProfileLocationApiV1InternalUsersIdProfileLocationPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetMemberProfileLocationApiV1InternalUsersIdProfileLocationPutResponse, SetMemberProfileLocationApiV1InternalUsersIdProfileLocationPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/profile/location',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Edit Member Profile Measurements
 */
export const editMemberProfileMeasurementsApiV1InternalUsersIdProfileMeasurementsPut = <ThrowOnError extends boolean = false>(options: Options<EditMemberProfileMeasurementsApiV1InternalUsersIdProfileMeasurementsPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditMemberProfileMeasurementsApiV1InternalUsersIdProfileMeasurementsPutResponse, EditMemberProfileMeasurementsApiV1InternalUsersIdProfileMeasurementsPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/profile/measurements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Edit Member Personal Profile
 */
export const editMemberPersonalProfileApiV1InternalUsersIdProfilePersonalPut = <ThrowOnError extends boolean = false>(options: Options<EditMemberPersonalProfileApiV1InternalUsersIdProfilePersonalPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditMemberPersonalProfileApiV1InternalUsersIdProfilePersonalPutResponse, EditMemberPersonalProfileApiV1InternalUsersIdProfilePersonalPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/profile/personal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Edit Member Profile Presentation
 */
export const editMemberProfilePresentationApiV1InternalUsersIdProfilePresentationPut = <ThrowOnError extends boolean = false>(options: Options<EditMemberProfilePresentationApiV1InternalUsersIdProfilePresentationPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditMemberProfilePresentationApiV1InternalUsersIdProfilePresentationPutResponse, EditMemberProfilePresentationApiV1InternalUsersIdProfilePresentationPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/profile/presentation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Edit Member Profile Privacy
 * The console's privacy dialog: the member's three consents, each recorded in
 * `consent_history` with the operator as the source.
 */
export const editMemberProfilePrivacyApiV1InternalUsersIdProfilePrivacyPut = <ThrowOnError extends boolean = false>(options: Options<EditMemberProfilePrivacyApiV1InternalUsersIdProfilePrivacyPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditMemberProfilePrivacyApiV1InternalUsersIdProfilePrivacyPutResponse, EditMemberProfilePrivacyApiV1InternalUsersIdProfilePrivacyPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/profile/privacy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Searches
 */
export const memberSearchesApiV1InternalUsersIdSearchesGet = <ThrowOnError extends boolean = false>(options: Options<MemberSearchesApiV1InternalUsersIdSearchesGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberSearchesApiV1InternalUsersIdSearchesGetResponse, MemberSearchesApiV1InternalUsersIdSearchesGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/searches',
        ...options
    });
};

/**
 * Member Search
 * One search and what it found, in the order the member saw it.
 *
 * Each result is resolved as it stands now; `available` is false for one that has
 * since been archived, hidden or deleted.
 */
export const memberSearchApiV1InternalUsersIdSearchesSearchIdGet = <ThrowOnError extends boolean = false>(options: Options<MemberSearchApiV1InternalUsersIdSearchesSearchIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberSearchApiV1InternalUsersIdSearchesSearchIdGetResponse, MemberSearchApiV1InternalUsersIdSearchesSearchIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/searches/{search_id}',
        ...options
    });
};

/**
 * Rerun Member Search
 * Run a wardrobe search again now, as the member's app would, without recording it.
 *
 * A smart search is refused with 422 `smart_search_rerun_unsupported`: re-running it
 * would be a paid model call on the member's behalf.
 */
export const rerunMemberSearchApiV1InternalUsersIdSearchesSearchIdRerunPost = <ThrowOnError extends boolean = false>(options: Options<RerunMemberSearchApiV1InternalUsersIdSearchesSearchIdRerunPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RerunMemberSearchApiV1InternalUsersIdSearchesSearchIdRerunPostResponse, RerunMemberSearchApiV1InternalUsersIdSearchesSearchIdRerunPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/searches/{search_id}/rerun',
        ...options
    });
};

/**
 * Upload Member Twin Photo
 * Upload a twin photo supplied by an operator for the path member.
 *
 * Deliberately reverses Round 2's exclusion of on-behalf avatar-candidate
 * capture on the grounds that it needed the member's own device, for this
 * capability only. A reason and Idempotency-Key are mandatory.
 */
export const uploadMemberTwinPhoto = <ThrowOnError extends boolean = false>(options: Options<UploadMemberTwinPhotoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadMemberTwinPhotoResponse, UploadMemberTwinPhotoError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/twin/from-photos',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Member Usage Limits
 */
export const memberUsageLimitsApiV1InternalUsersIdUsageLimitsGet = <ThrowOnError extends boolean = false>(options: Options<MemberUsageLimitsApiV1InternalUsersIdUsageLimitsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberUsageLimitsApiV1InternalUsersIdUsageLimitsGetResponse, MemberUsageLimitsApiV1InternalUsersIdUsageLimitsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/usage-limits',
        ...options
    });
};

/**
 * Set Member Usage Limits
 * Raise or clear one member's daily allowances.
 *
 * Answers with the resolved allowances rather than the stored override,
 * because those are not always the same number and the effective one is
 * what the operator came to change. A 404 here means the member has no
 * interaction profile yet - they have not used the app - which is worth
 * distinguishing from the override having been saved.
 */
export const setMemberUsageLimitsApiV1InternalUsersIdUsageLimitsPut = <ThrowOnError extends boolean = false>(options: Options<SetMemberUsageLimitsApiV1InternalUsersIdUsageLimitsPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetMemberUsageLimitsApiV1InternalUsersIdUsageLimitsPutResponse, SetMemberUsageLimitsApiV1InternalUsersIdUsageLimitsPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/usage-limits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Wardrobe
 */
export const memberWardrobeApiV1InternalUsersIdWardrobeGet = <ThrowOnError extends boolean = false>(options: Options<MemberWardrobeApiV1InternalUsersIdWardrobeGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberWardrobeApiV1InternalUsersIdWardrobeGetResponse, MemberWardrobeApiV1InternalUsersIdWardrobeGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe',
        ...options
    });
};

/**
 * Member Wardrobe Folders
 */
export const memberWardrobeFoldersApiV1InternalUsersIdWardrobeFoldersGet = <ThrowOnError extends boolean = false>(options: Options<MemberWardrobeFoldersApiV1InternalUsersIdWardrobeFoldersGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberWardrobeFoldersApiV1InternalUsersIdWardrobeFoldersGetResponse, MemberWardrobeFoldersApiV1InternalUsersIdWardrobeFoldersGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe-folders',
        ...options
    });
};

/**
 * Create Member Wardrobe Folder
 */
export const createMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersPost = <ThrowOnError extends boolean = false>(options: Options<CreateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersPostResponse, CreateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe-folders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Member Wardrobe Folder
 */
export const deleteMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdDeleteResponse, DeleteMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe-folders/{folder_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Wardrobe Folder
 */
export const memberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdGet = <ThrowOnError extends boolean = false>(options: Options<MemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdGetResponse, MemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe-folders/{folder_id}',
        ...options
    });
};

/**
 * Update Member Wardrobe Folder
 */
export const updateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdPatchResponse, UpdateMemberWardrobeFolderApiV1InternalUsersIdWardrobeFoldersFolderIdPatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe-folders/{folder_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Remove Member Wardrobe Folder Garment
 */
export const removeMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdDelete = <ThrowOnError extends boolean = false>(options: Options<RemoveMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdDeleteResponse, RemoveMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe-folders/{folder_id}/garments/{garment_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Put Member Wardrobe Folder Garment
 */
export const putMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdPut = <ThrowOnError extends boolean = false>(options: Options<PutMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdPutResponse, PutMemberWardrobeFolderGarmentApiV1InternalUsersIdWardrobeFoldersFolderIdGarmentsGarmentIdPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe-folders/{folder_id}/garments/{garment_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Mutate Member Wardrobe Folder Outfits
 */
export const mutateMemberWardrobeFolderOutfitsApiV1InternalUsersIdWardrobeFoldersFolderIdOutfitsPost = <ThrowOnError extends boolean = false>(options: Options<MutateMemberWardrobeFolderOutfitsApiV1InternalUsersIdWardrobeFoldersFolderIdOutfitsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MutateMemberWardrobeFolderOutfitsApiV1InternalUsersIdWardrobeFoldersFolderIdOutfitsPostResponse, MutateMemberWardrobeFolderOutfitsApiV1InternalUsersIdWardrobeFoldersFolderIdOutfitsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe-folders/{folder_id}/outfits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Bulk Member Garments
 * Apply one garment verb to a selection of a member's garments.
 *
 * The route permission is wardrobe review, because three of the four verbs
 * are reversible and an operator clearing up a member's wardrobe should not
 * need a destructive grant to archive forty duplicates. `remove` is the one
 * that is not reversible, so it is checked against `DESTRUCTIVE_ACTIONS`
 * here rather than at the door - the same shape as `/controls`, which holds
 * a second permission for `replay_event` alone. Declaring the whole route
 * destructive would have priced the other three out of a manager's reach.
 *
 * The response reports every garment individually. A batch that half worked
 * and reported a number would leave the operator to find the rest by hand,
 * and the refusals are not interchangeable: `no_source` needs another photo
 * from the member and `limited` needs only a minute.
 */
export const bulkMemberGarmentsApiV1InternalUsersIdWardrobeGarmentsBulkPost = <ThrowOnError extends boolean = false>(options: Options<BulkMemberGarmentsApiV1InternalUsersIdWardrobeGarmentsBulkPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BulkMemberGarmentsApiV1InternalUsersIdWardrobeGarmentsBulkPostResponse, BulkMemberGarmentsApiV1InternalUsersIdWardrobeGarmentsBulkPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Member Garments Bulk
 * Permanently delete the named garments, or with `all` the member's oldest 500.
 *
 * Call again with `all` until `remaining` is zero to clear a larger wardrobe.
 */
export const deleteMemberGarmentsBulkApiV1InternalUsersIdWardrobeGarmentsDeleteBulkPost = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberGarmentsBulkApiV1InternalUsersIdWardrobeGarmentsDeleteBulkPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteMemberGarmentsBulkApiV1InternalUsersIdWardrobeGarmentsDeleteBulkPostResponse, DeleteMemberGarmentsBulkApiV1InternalUsersIdWardrobeGarmentsDeleteBulkPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/delete-bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Remove Member Garment
 * Remove one garment from a member's wardrobe, as the operator.
 *
 * The same removal the member can perform themselves, through the same
 * service. What differs is the record it leaves: the operator is the actor
 * and the member is the subject, so this cannot later read as the member
 * having removed their own garment.
 */
export const removeMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdDelete = <ThrowOnError extends boolean = false>(options: Options<RemoveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdDeleteResponse, RemoveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/{garment_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Edit Garment Quality Override
 */
export const editGarmentQualityOverrideApiV1InternalUsersIdWardrobeGarmentsGarmentIdPatch = <ThrowOnError extends boolean = false>(options: Options<EditGarmentQualityOverrideApiV1InternalUsersIdWardrobeGarmentsGarmentIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<EditGarmentQualityOverrideApiV1InternalUsersIdWardrobeGarmentsGarmentIdPatchResponse, EditGarmentQualityOverrideApiV1InternalUsersIdWardrobeGarmentsGarmentIdPatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/{garment_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Archive Member Garment
 * Archive one of a member's garments, recorded as the operator's decision.
 *
 * `expected_version` is required for the same reason it is on the member's
 * own route: the archive counter is the only thing standing between two
 * simultaneous decisions and a silently lost one. A stale one is a 409, not
 * a retry - the operator is being told the garment moved under them.
 */
export const archiveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdArchivePost = <ThrowOnError extends boolean = false>(options: Options<ArchiveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdArchivePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ArchiveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdArchivePostResponse, ArchiveMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdArchivePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/{garment_id}/archive',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Garment Pairings
 * What pairs with one of the member's garments, as their garment detail ranks it.
 *
 * Rejected pairings are left out. Items with `shown_to_member` are the ones the
 * member's "Pairs Best With" shows right now.
 */
export const memberGarmentPairingsApiV1InternalUsersIdWardrobeGarmentsGarmentIdPairingsGet = <ThrowOnError extends boolean = false>(options: Options<MemberGarmentPairingsApiV1InternalUsersIdWardrobeGarmentsGarmentIdPairingsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberGarmentPairingsApiV1InternalUsersIdWardrobeGarmentsGarmentIdPairingsGetResponse, MemberGarmentPairingsApiV1InternalUsersIdWardrobeGarmentsGarmentIdPairingsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/{garment_id}/pairings',
        ...options
    });
};

/**
 * Delete Member Garment Permanently
 * Permanently delete one of the member's garments, with everything that hangs off it.
 *
 * Unlike the archive above, nothing is left to restore. Each outfit, OOTD candidate
 * or combo wearing it loses it, and one left with fewer than two garments is deleted
 * as the outfit delete does; its images go once nothing else uses them.
 */
export const deleteMemberGarmentPermanentlyApiV1InternalUsersIdWardrobeGarmentsGarmentIdPermanentDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberGarmentPermanentlyApiV1InternalUsersIdWardrobeGarmentsGarmentIdPermanentDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMemberGarmentPermanentlyApiV1InternalUsersIdWardrobeGarmentsGarmentIdPermanentDeleteResponse, DeleteMemberGarmentPermanentlyApiV1InternalUsersIdWardrobeGarmentsGarmentIdPermanentDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/{garment_id}/permanent',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reprocess Member Garment
 * Re-run ingestion on one of a member's garments.
 *
 * The intake service's refusals are forwarded with the status it chose, so
 * the four ways this can fail stay four different answers: no such garment
 * (404), one already removed (410), one with no source image left to work
 * from (400), and one whose reprocess is already running (429). Reported as
 * one generic failure they would all read as "try again", and only one of
 * them is worth trying again.
 */
export const reprocessMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdReprocessPost = <ThrowOnError extends boolean = false>(options: Options<ReprocessMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdReprocessPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReprocessMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdReprocessPostResponse, ReprocessMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdReprocessPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/{garment_id}/reprocess',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Requeue Member Garment Ingestion
 * Put one member's garment back through the live ingestion pipeline.
 *
 * 202, not 200: nothing has been re-ingested when this returns, a job has
 * been queued to do it. Reporting completion here would have an operator
 * check the garment a second later, see the old attributes and requeue
 * again - paying twice for one fix.
 *
 * `Idempotency-Key` is required rather than optional for that same reason.
 * Every stage of this pipeline is a paid provider call, and the one input
 * that makes a double-submitted requeue collapse into a single job is a key
 * the operator's client sends on both attempts.
 */
export const requeueMemberGarmentIngestionApiV1InternalUsersIdWardrobeGarmentsGarmentIdRequeueIngestionPost = <ThrowOnError extends boolean = false>(options: Options<RequeueMemberGarmentIngestionApiV1InternalUsersIdWardrobeGarmentsGarmentIdRequeueIngestionPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RequeueMemberGarmentIngestionApiV1InternalUsersIdWardrobeGarmentsGarmentIdRequeueIngestionPostResponse, RequeueMemberGarmentIngestionApiV1InternalUsersIdWardrobeGarmentsGarmentIdRequeueIngestionPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/{garment_id}/requeue-ingestion',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Restore Member Garment
 * Bring one of a member's archived garments back, as the operator.
 */
export const restoreMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdRestorePost = <ThrowOnError extends boolean = false>(options: Options<RestoreMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdRestorePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RestoreMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdRestorePostResponse, RestoreMemberGarmentApiV1InternalUsersIdWardrobeGarmentsGarmentIdRestorePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/{garment_id}/restore',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Edit Member Garment Tags
 * Edit one member garment through the same attribute merge they use.
 */
export const editMemberGarmentTagsApiV1InternalUsersIdWardrobeGarmentsGarmentIdTagsPost = <ThrowOnError extends boolean = false>(options: Options<EditMemberGarmentTagsApiV1InternalUsersIdWardrobeGarmentsGarmentIdTagsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EditMemberGarmentTagsApiV1InternalUsersIdWardrobeGarmentsGarmentIdTagsPostResponse, EditMemberGarmentTagsApiV1InternalUsersIdWardrobeGarmentsGarmentIdTagsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/garments/{garment_id}/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Member Wardrobe Summary
 */
export const memberWardrobeSummaryApiV1InternalUsersIdWardrobeSummaryGet = <ThrowOnError extends boolean = false>(options: Options<MemberWardrobeSummaryApiV1InternalUsersIdWardrobeSummaryGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberWardrobeSummaryApiV1InternalUsersIdWardrobeSummaryGetResponse, MemberWardrobeSummaryApiV1InternalUsersIdWardrobeSummaryGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{id}/wardrobe/summary',
        ...options
    });
};

/**
 * Member Deletion Request
 * The member's deletion request, or `request: null` when they never made one.
 *
 * Null rather than 404 deliberately: a member with no deletion request is the
 * normal case, and returning an error for it would make an operator screen
 * render a failure for every healthy member.
 */
export const memberDeletionRequestApiV1InternalUsersMemberIdDeletionRequestGet = <ThrowOnError extends boolean = false>(options: Options<MemberDeletionRequestApiV1InternalUsersMemberIdDeletionRequestGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberDeletionRequestApiV1InternalUsersMemberIdDeletionRequestGetResponse, MemberDeletionRequestApiV1InternalUsersMemberIdDeletionRequestGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/users/{member_id}/deletion-request',
        ...options
    });
};

/**
 * List Wardrobe Bulk Imports
 * List stored import and member progress, including stalled imports: the
 * console's Drive import status panel.
 */
export const listWardrobeBulkImportsApiV1InternalWardrobeBulkImportsGet = <ThrowOnError extends boolean = false>(options?: Options<ListWardrobeBulkImportsApiV1InternalWardrobeBulkImportsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListWardrobeBulkImportsApiV1InternalWardrobeBulkImportsGetResponse, ListWardrobeBulkImportsApiV1InternalWardrobeBulkImportsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/wardrobe/bulk-imports',
        ...options
    });
};

/**
 * Create Wardrobe Bulk Import
 * Validate a Drive-link + member manifest, write the tracking rows, and
 * enqueue exactly one `wardrobe_bulk_import` execution. Only a bounded,
 * shallow folder probe runs here; recursive discovery and garment ingestion
 * happen on the `durable` worker family.
 */
export const createWardrobeBulkImportApiV1InternalWardrobeBulkImportsPost = <ThrowOnError extends boolean = false>(options: Options<CreateWardrobeBulkImportApiV1InternalWardrobeBulkImportsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateWardrobeBulkImportApiV1InternalWardrobeBulkImportsPostResponse, CreateWardrobeBulkImportApiV1InternalWardrobeBulkImportsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/wardrobe/bulk-imports',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Wardrobe Bulk Import
 */
export const getWardrobeBulkImportApiV1InternalWardrobeBulkImportsImportIdGet = <ThrowOnError extends boolean = false>(options: Options<GetWardrobeBulkImportApiV1InternalWardrobeBulkImportsImportIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWardrobeBulkImportApiV1InternalWardrobeBulkImportsImportIdGetResponse, GetWardrobeBulkImportApiV1InternalWardrobeBulkImportsImportIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/wardrobe/bulk-imports/{import_id}',
        ...options
    });
};

/**
 * List Wardrobe Bulk Import Items
 * Every Drive file with its garment-ingestion stage and state.
 *
 * Imports created before the per-file ledger temporarily retain the legacy
 * eight-stage projection. Read-only; the same permission as import status.
 */
export const listWardrobeBulkImportItemsApiV1InternalWardrobeBulkImportsImportIdItemsGet = <ThrowOnError extends boolean = false>(options: Options<ListWardrobeBulkImportItemsApiV1InternalWardrobeBulkImportsImportIdItemsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListWardrobeBulkImportItemsApiV1InternalWardrobeBulkImportsImportIdItemsGetResponse, ListWardrobeBulkImportItemsApiV1InternalWardrobeBulkImportsImportIdItemsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/wardrobe/bulk-imports/{import_id}/items',
        ...options
    });
};

/**
 * Wardrobe Composition
 * Fleet-wide garment composition across every pilot member at once.
 *
 * Distinct from ``GET /users/{id}/wardrobe/summary`` - that one is scoped to a
 * single member and this one never is; the two never share a query path.
 */
export const wardrobeCompositionApiV1InternalWardrobeCompositionGet = <ThrowOnError extends boolean = false>(options?: Options<WardrobeCompositionApiV1InternalWardrobeCompositionGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<WardrobeCompositionApiV1InternalWardrobeCompositionGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/wardrobe/composition',
        ...options
    });
};

/**
 * Wardrobe Composition Garments
 */
export const wardrobeCompositionGarmentsApiV1InternalWardrobeCompositionGarmentsGet = <ThrowOnError extends boolean = false>(options?: Options<WardrobeCompositionGarmentsApiV1InternalWardrobeCompositionGarmentsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<WardrobeCompositionGarmentsApiV1InternalWardrobeCompositionGarmentsGetResponse, WardrobeCompositionGarmentsApiV1InternalWardrobeCompositionGarmentsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/wardrobe/composition/garments',
        ...options
    });
};

/**
 * Create Member Garment
 * Queue one garment from a completed wardrobe_garment media upload.
 *
 * It enters the member intake and runs the `garment_ingestion` workflow,
 * the same as a garment the member uploads themselves.
 */
export const createMemberGarmentApiV1InternalWardrobeMembersMemberIdGarmentsPost = <ThrowOnError extends boolean = false>(options: Options<CreateMemberGarmentApiV1InternalWardrobeMembersMemberIdGarmentsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMemberGarmentApiV1InternalWardrobeMembersMemberIdGarmentsPostResponse, CreateMemberGarmentApiV1InternalWardrobeMembersMemberIdGarmentsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/wardrobe/members/{member_id}/garments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Garment Quality Check
 */
export const listGarmentQualityCheckApiV1InternalWardrobeQualityCheckGet = <ThrowOnError extends boolean = false>(options?: Options<ListGarmentQualityCheckApiV1InternalWardrobeQualityCheckGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListGarmentQualityCheckApiV1InternalWardrobeQualityCheckGetResponse, ListGarmentQualityCheckApiV1InternalWardrobeQualityCheckGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/wardrobe/quality-check',
        ...options
    });
};

/**
 * Apply Garment Quality Check Actions
 */
export const applyGarmentQualityCheckActionsApiV1InternalWardrobeQualityCheckActionsPost = <ThrowOnError extends boolean = false>(options: Options<ApplyGarmentQualityCheckActionsApiV1InternalWardrobeQualityCheckActionsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApplyGarmentQualityCheckActionsApiV1InternalWardrobeQualityCheckActionsPostResponse, ApplyGarmentQualityCheckActionsApiV1InternalWardrobeQualityCheckActionsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/wardrobe/quality-check/actions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List Jobs
 * One row per job, newest first. `before` pages by job id for a stable
 * keyset cursor (created_at is not unique enough alone under load).
 * `member_id` keeps one member's runs, served by `ix_fastapi_worker_jobs_member`.
 */
export const listJobsApiV1InternalWorkflowJobsJobsGet = <ThrowOnError extends boolean = false>(options?: Options<ListJobsApiV1InternalWorkflowJobsJobsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListJobsApiV1InternalWorkflowJobsJobsGetResponse, ListJobsApiV1InternalWorkflowJobsJobsGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/workflow-jobs/jobs',
        ...options
    });
};

/**
 * Get Job
 * Job detail plus its step progress: the latest `workflow.step_progress`
 * checkpoint carries the accumulated `completed` step results and `logs`
 * for every step in the run (see `app.runtime.workflow.WorkflowRun`).
 *
 * Each entry in `checkpoints` additionally carries the step's own recorded
 * `inputs` and `outputs` (denylist-redacted and byte-capped when written -
 * see `app.runtime.checkpoint_io`) alongside its `output_references`.
 *
 * `inputs`/`outputs` are `null` for any checkpoint written before step I/O
 * recording existed, or by a handler that supplies none - "not recorded for
 * this run". That is deliberately distinct from `{}`, which means the step
 * recorded its I/O and genuinely had none. Historical rows are not
 * backfilled, so the console must render those two differently.
 *
 * `pipeline_stages` contains garment stage attempts correlated by the writer's
 * `worker_job_id`, with input/output media signed for 900 seconds. Discovery
 * is bounded per stage to depth 8, 32 refs, and 2,048 values. Empty media is [].
 * Source reference blobs are not copied into this new projection.
 *
 * `events` is the job's lifecycle timeline from `fastapi_worker_job_events`
 * (enqueued, claimed, progress with `progress_current`/`progress_total` and a
 * stage `code`, dead_lettered with its `code` and `reference_id`, ...): the
 * newest 200, returned in ascending `sequence`. A plain durable job that
 * writes no checkpoints still has a timeline. The event `details` JSON is omitted.
 *
 * Additive only: no existing field changed name or shape.
 */
export const getJobApiV1InternalWorkflowJobsJobsJobIdGet = <ThrowOnError extends boolean = false>(options: Options<GetJobApiV1InternalWorkflowJobsJobsJobIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJobApiV1InternalWorkflowJobsJobsJobIdGetResponse, GetJobApiV1InternalWorkflowJobsJobsJobIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/workflow-jobs/jobs/{job_id}',
        ...options
    });
};

/**
 * Cancel Job
 * Cancel a job. Immediate for a queued/retry-wait job; for a running
 * job this only requests cancellation - the running worker observes it
 * and finishes the job as cancelled on its own.
 */
export const cancelJobApiV1InternalWorkflowJobsJobsJobIdCancelPost = <ThrowOnError extends boolean = false>(options: Options<CancelJobApiV1InternalWorkflowJobsJobsJobIdCancelPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelJobApiV1InternalWorkflowJobsJobsJobIdCancelPostResponse, CancelJobApiV1InternalWorkflowJobsJobsJobIdCancelPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/workflow-jobs/jobs/{job_id}/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Checkpoint Media
 * Stream the image one of this job's own references points at, for an
 * operator preview.
 *
 * Deliberately NOT a signed URL. These references point at member wardrobe
 * photos and generated twin images; a presigned URL is a bearer capability
 * that keeps working from anywhere until it expires, including once it has
 * been pasted into a ticket or a chat. The console sits behind Cloudflare
 * Access and an operator role, and the image must not escape that boundary,
 * so the bytes are proxied and the URL never leaves this process.
 *
 * The security-critical part is the ownership check below. Without it this
 * endpoint is an arbitrary object-storage read oracle for anyone holding the
 * internal service token: pass any key, get any object. So the reference is
 * never taken from the caller as a storage key - it is only honoured when it
 * appears verbatim as a value in *this* job's own payload, or in the
 * `inputs`, `outputs` or `output_references` of one of its checkpoint rows.
 * A reference that belongs to a different job, or to no job at all, is
 * refused with 404 and never reaches storage. Only once ownership holds is a
 * signed URL reduced to its key or a logical asset id resolved, so neither
 * form can smuggle in a key the job does not hold.
 */
export const getCheckpointMediaApiV1InternalWorkflowJobsJobsJobIdCheckpointMediaGet = <ThrowOnError extends boolean = false>(options: Options<GetCheckpointMediaApiV1InternalWorkflowJobsJobsJobIdCheckpointMediaGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, GetCheckpointMediaApiV1InternalWorkflowJobsJobsJobIdCheckpointMediaGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/workflow-jobs/jobs/{job_id}/checkpoint-media',
        ...options
    });
};

/**
 * Resume Job
 * Redrive a job an operator cancelled. Rejects any other status - use
 * /retry for a dead-lettered job instead.
 */
export const resumeJobApiV1InternalWorkflowJobsJobsJobIdResumePost = <ThrowOnError extends boolean = false>(options: Options<ResumeJobApiV1InternalWorkflowJobsJobsJobIdResumePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResumeJobApiV1InternalWorkflowJobsJobsJobIdResumePostResponse, ResumeJobApiV1InternalWorkflowJobsJobsJobIdResumePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/workflow-jobs/jobs/{job_id}/resume',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retry Job
 * Redrive a dead-lettered job. Rejects any other status - use /resume
 * for a cancelled job instead.
 */
export const retryJobApiV1InternalWorkflowJobsJobsJobIdRetryPost = <ThrowOnError extends boolean = false>(options: Options<RetryJobApiV1InternalWorkflowJobsJobsJobIdRetryPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetryJobApiV1InternalWorkflowJobsJobsJobIdRetryPostResponse, RetryJobApiV1InternalWorkflowJobsJobsJobIdRetryPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/workflow-jobs/jobs/{job_id}/retry',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List Workflow Families
 * Every family with at least one real job row, for the Jobs screen's
 * sidebar.
 *
 * Deliberately NOT `app.runtime.workflow.discover_workflows()`/`REGISTRY`:
 * every workflow added via the builder pattern (`build_X_workflow(deps, *,
 * family=...)`) only self-registers with `@workflow` when the builder is
 * actually CALLED with real dependencies - which only happens inside
 * `app.runtime.job_registry`'s handler factories at real worker startup, not
 * on module import. Calling those factories here to populate the registry
 * would require this API process to hold full worker credentials
 * (`create_convergence_durable_job_handlers` raises without a real
 * `REPLICATE_API_KEY`, for instance) just to answer "what families exist" -
 * a real credential-scope violation for a read-only reporting endpoint.
 * Reading distinct `kind` values out of real job history has no such
 * dependency and reflects what has actually run, not just what's coded.
 */
export const listWorkflowFamiliesApiV1InternalWorkflowJobsWorkflowsGet = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowFamiliesApiV1InternalWorkflowJobsWorkflowsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListWorkflowFamiliesApiV1InternalWorkflowJobsWorkflowsGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/workflow-jobs/workflows',
        ...options
    });
};

/**
 * Explorer
 */
export const explorerApiV1InternalExplorerGet = <ThrowOnError extends boolean = false>(options: Options<ExplorerApiV1InternalExplorerGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExplorerApiV1InternalExplorerGetResponse, ExplorerApiV1InternalExplorerGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/{explorer}',
        ...options
    });
};

/**
 * Liveness
 */
export const livenessApiV1LivenessGet = <ThrowOnError extends boolean = false>(options?: Options<LivenessApiV1LivenessGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LivenessApiV1LivenessGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/liveness',
        ...options
    });
};

/**
 * Create Media Upload
 */
export const createMediaUploadApiV1MediaUploadsPost = <ThrowOnError extends boolean = false>(options: Options<CreateMediaUploadApiV1MediaUploadsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMediaUploadApiV1MediaUploadsPostResponse, CreateMediaUploadApiV1MediaUploadsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/media/uploads',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Complete Media Upload
 */
export const completeMediaUploadApiV1MediaUploadsIdCompletePost = <ThrowOnError extends boolean = false>(options: Options<CompleteMediaUploadApiV1MediaUploadsIdCompletePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CompleteMediaUploadApiV1MediaUploadsIdCompletePostResponse, CompleteMediaUploadApiV1MediaUploadsIdCompletePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/media/uploads/{id}/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Readiness
 */
export const readinessApiV1ReadinessGet = <ThrowOnError extends boolean = false>(options?: Options<ReadinessApiV1ReadinessGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReadinessApiV1ReadinessGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/readiness',
        ...options
    });
};

/**
 * Redis Health
 */
export const redisHealthApiV1RedisGet = <ThrowOnError extends boolean = false>(options?: Options<RedisHealthApiV1RedisGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RedisHealthApiV1RedisGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/redis',
        ...options
    });
};

/**
 * Storage
 */
export const storageApiV1StorageGet = <ThrowOnError extends boolean = false>(options?: Options<StorageApiV1StorageGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StorageApiV1StorageGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/storage',
        ...options
    });
};

/**
 * Dashboard
 */
export const dashboardApiV1StylistDashboardGet = <ThrowOnError extends boolean = false>(options?: Options<DashboardApiV1StylistDashboardGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardApiV1StylistDashboardGetResponse, DashboardApiV1StylistDashboardGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/dashboard',
        ...options
    });
};

/**
 * Member
 */
export const memberApiV1StylistMembersUserIdGet = <ThrowOnError extends boolean = false>(options: Options<MemberApiV1StylistMembersUserIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberApiV1StylistMembersUserIdGetResponse, MemberApiV1StylistMembersUserIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/members/{user_id}',
        ...options
    });
};

/**
 * Day Ahead Queue
 * List slots with member and garment details for stylist review.
 */
export const dayAheadQueueApiV1StylistOotdDayAheadQueueGet = <ThrowOnError extends boolean = false>(options?: Options<DayAheadQueueApiV1StylistOotdDayAheadQueueGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DayAheadQueueApiV1StylistOotdDayAheadQueueGetResponse, DayAheadQueueApiV1StylistOotdDayAheadQueueGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/ootd/day-ahead/queue',
        ...options
    });
};

/**
 * Day Ahead Slot
 * One day-ahead slot by id, in the queue's shape, whatever its review status.
 */
export const dayAheadSlotApiV1StylistOotdDayAheadSlotIdGet = <ThrowOnError extends boolean = false>(options: Options<DayAheadSlotApiV1StylistOotdDayAheadSlotIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DayAheadSlotApiV1StylistOotdDayAheadSlotIdGetResponse, DayAheadSlotApiV1StylistOotdDayAheadSlotIdGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/ootd/day-ahead/{slot_id}',
        ...options
    });
};

/**
 * Day Ahead Decision
 * A stylist approves (``final_garment_ids`` matching what was
 * generated) or edits (a different set) one day-ahead look - one route for
 * both. Rejecting is ``POST .../{slot_id}/reject``. Fires the avatar render
 * immediately.
 */
export const dayAheadDecisionApiV1StylistOotdDayAheadSlotIdDecisionPost = <ThrowOnError extends boolean = false>(options: Options<DayAheadDecisionApiV1StylistOotdDayAheadSlotIdDecisionPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DayAheadDecisionApiV1StylistOotdDayAheadSlotIdDecisionPostResponse, DayAheadDecisionApiV1StylistOotdDayAheadSlotIdDecisionPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/ootd/day-ahead/{slot_id}/decision',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Day Ahead Reject
 * A stylist rejects one day-ahead look in review. The look is kept as ``rejected`` and a
 * replacement with the same ``look_index`` is generated; it comes back to the queue as
 * ``awaiting_review``. Repeating the request returns the same replacement (``idempotent``).
 * 409 when the look is not in review (approved, shipped, still generating).
 */
export const dayAheadRejectApiV1StylistOotdDayAheadSlotIdRejectPost = <ThrowOnError extends boolean = false>(options: Options<DayAheadRejectApiV1StylistOotdDayAheadSlotIdRejectPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DayAheadRejectApiV1StylistOotdDayAheadSlotIdRejectPostResponse, DayAheadRejectApiV1StylistOotdDayAheadSlotIdRejectPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/ootd/day-ahead/{slot_id}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Day Ahead Wardrobe
 * List the slot member's eligible garments for the day-ahead picker.
 */
export const dayAheadWardrobeApiV1StylistOotdDayAheadSlotIdWardrobeGet = <ThrowOnError extends boolean = false>(options: Options<DayAheadWardrobeApiV1StylistOotdDayAheadSlotIdWardrobeGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DayAheadWardrobeApiV1StylistOotdDayAheadSlotIdWardrobeGetResponse, DayAheadWardrobeApiV1StylistOotdDayAheadSlotIdWardrobeGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/ootd/day-ahead/{slot_id}/wardrobe',
        ...options
    });
};

/**
 * Credit Look
 */
export const creditLookApiV1StylistWorkbenchLooksOutfitIdCreditPost = <ThrowOnError extends boolean = false>(options: Options<CreditLookApiV1StylistWorkbenchLooksOutfitIdCreditPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreditLookApiV1StylistWorkbenchLooksOutfitIdCreditPostResponse, CreditLookApiV1StylistWorkbenchLooksOutfitIdCreditPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/workbench/looks/{outfit_id}/credit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Replace Look
 */
export const replaceLookApiV1StylistWorkbenchLooksOutfitIdReplacePost = <ThrowOnError extends boolean = false>(options: Options<ReplaceLookApiV1StylistWorkbenchLooksOutfitIdReplacePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReplaceLookApiV1StylistWorkbenchLooksOutfitIdReplacePostResponse, ReplaceLookApiV1StylistWorkbenchLooksOutfitIdReplacePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/workbench/looks/{outfit_id}/replace',
        ...options
    });
};

/**
 * Remove Cart Item
 */
export const removeCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdDelete = <ThrowOnError extends boolean = false>(options: Options<RemoveCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdDeleteResponse, RemoveCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/workbench/members/{member_id}/cart/{product_id}',
        ...options
    });
};

/**
 * Upsert Cart Item
 */
export const upsertCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdPut = <ThrowOnError extends boolean = false>(options: Options<UpsertCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpsertCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdPutResponse, UpsertCartItemApiV1StylistWorkbenchMembersMemberIdCartProductIdPutError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/workbench/members/{member_id}/cart/{product_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Create Look
 */
export const createLookApiV1StylistWorkbenchMembersMemberIdLooksPost = <ThrowOnError extends boolean = false>(options: Options<CreateLookApiV1StylistWorkbenchMembersMemberIdLooksPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateLookApiV1StylistWorkbenchMembersMemberIdLooksPostResponse, CreateLookApiV1StylistWorkbenchMembersMemberIdLooksPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/workbench/members/{member_id}/looks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * State
 */
export const stateApiV1StylistWorkbenchStateGet = <ThrowOnError extends boolean = false>(options?: Options<StateApiV1StylistWorkbenchStateGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StateApiV1StylistWorkbenchStateGetResponse, StateApiV1StylistWorkbenchStateGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/workbench/state',
        ...options
    });
};

/**
 * Accept Thread
 */
export const acceptThreadApiV1StylistWorkbenchThreadsThreadIdAcceptPost = <ThrowOnError extends boolean = false>(options: Options<AcceptThreadApiV1StylistWorkbenchThreadsThreadIdAcceptPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AcceptThreadApiV1StylistWorkbenchThreadsThreadIdAcceptPostResponse, AcceptThreadApiV1StylistWorkbenchThreadsThreadIdAcceptPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/workbench/threads/{thread_id}/accept',
        ...options
    });
};

/**
 * Publish Cart
 */
export const publishCartApiV1StylistWorkbenchThreadsThreadIdCartPublishPost = <ThrowOnError extends boolean = false>(options: Options<PublishCartApiV1StylistWorkbenchThreadsThreadIdCartPublishPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PublishCartApiV1StylistWorkbenchThreadsThreadIdCartPublishPostResponse, PublishCartApiV1StylistWorkbenchThreadsThreadIdCartPublishPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/workbench/threads/{thread_id}/cart/publish',
        ...options
    });
};

/**
 * Send Message
 */
export const sendMessageApiV1StylistWorkbenchThreadsThreadIdMessagesPost = <ThrowOnError extends boolean = false>(options: Options<SendMessageApiV1StylistWorkbenchThreadsThreadIdMessagesPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SendMessageApiV1StylistWorkbenchThreadsThreadIdMessagesPostResponse, SendMessageApiV1StylistWorkbenchThreadsThreadIdMessagesPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/stylist/workbench/threads/{thread_id}/messages',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Subscription
 */
export const subscriptionApiV1SubscriptionsGet = <ThrowOnError extends boolean = false>(options?: Options<SubscriptionApiV1SubscriptionsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SubscriptionApiV1SubscriptionsGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/subscriptions',
        ...options
    });
};

/**
 * Bill History
 */
export const billHistoryApiV1SubscriptionsBillHistoryGet = <ThrowOnError extends boolean = false>(options?: Options<BillHistoryApiV1SubscriptionsBillHistoryGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<BillHistoryApiV1SubscriptionsBillHistoryGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/subscriptions/bill-history',
        ...options
    });
};

/**
 * Cancel Subscription
 */
export const cancelSubscriptionApiV1SubscriptionsCancelPost = <ThrowOnError extends boolean = false>(options?: Options<CancelSubscriptionApiV1SubscriptionsCancelPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CancelSubscriptionApiV1SubscriptionsCancelPostResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/subscriptions/cancel',
        ...options
    });
};

/**
 * Subscription Checkout
 */
export const subscriptionCheckoutApiV1SubscriptionsCheckoutPost = <ThrowOnError extends boolean = false>(options: Options<SubscriptionCheckoutApiV1SubscriptionsCheckoutPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, SubscriptionCheckoutApiV1SubscriptionsCheckoutPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/subscriptions/checkout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Subscription Plans
 */
export const subscriptionPlansApiV1SubscriptionsPlansGet = <ThrowOnError extends boolean = false>(options?: Options<SubscriptionPlansApiV1SubscriptionsPlansGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/subscriptions/plans',
        ...options
    });
};

/**
 * Ingest Mobile Telemetry Batch
 * Durably queue one privacy-safe, versioned mobile telemetry batch.
 */
export const ingestMobileTelemetryBatchApiV1TelemetryMobileBatchesPost = <ThrowOnError extends boolean = false>(options: Options<IngestMobileTelemetryBatchApiV1TelemetryMobileBatchesPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestMobileTelemetryBatchApiV1TelemetryMobileBatchesPostResponse, IngestMobileTelemetryBatchApiV1TelemetryMobileBatchesPostError, ThrowOnError>({
        url: '/api/v1/telemetry/mobile/batches',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Version
 */
export const versionApiV1VersionGet = <ThrowOnError extends boolean = false>(options?: Options<VersionApiV1VersionGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<VersionApiV1VersionGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/version',
        ...options
    });
};

/**
 * List Folders
 */
export const listFoldersApiV1WardrobeFoldersGet = <ThrowOnError extends boolean = false>(options?: Options<ListFoldersApiV1WardrobeFoldersGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFoldersApiV1WardrobeFoldersGetResponse, ListFoldersApiV1WardrobeFoldersGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/wardrobe/folders',
        ...options
    });
};

/**
 * Create Folder
 */
export const createFolderApiV1WardrobeFoldersPost = <ThrowOnError extends boolean = false>(options: Options<CreateFolderApiV1WardrobeFoldersPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateFolderApiV1WardrobeFoldersPostResponse, CreateFolderApiV1WardrobeFoldersPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/wardrobe/folders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Folder
 */
export const deleteFolderApiV1WardrobeFoldersFolderIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteFolderApiV1WardrobeFoldersFolderIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteFolderApiV1WardrobeFoldersFolderIdDeleteResponse, DeleteFolderApiV1WardrobeFoldersFolderIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/wardrobe/folders/{folder_id}',
        ...options
    });
};

/**
 * Update Folder
 */
export const updateFolderApiV1WardrobeFoldersFolderIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateFolderApiV1WardrobeFoldersFolderIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateFolderApiV1WardrobeFoldersFolderIdPatchResponse, UpdateFolderApiV1WardrobeFoldersFolderIdPatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/wardrobe/folders/{folder_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Folder Detail
 */
export const getFolderDetailApiV1WardrobeFoldersFolderIdDetailGet = <ThrowOnError extends boolean = false>(options: Options<GetFolderDetailApiV1WardrobeFoldersFolderIdDetailGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFolderDetailApiV1WardrobeFoldersFolderIdDetailGetResponse, GetFolderDetailApiV1WardrobeFoldersFolderIdDetailGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/wardrobe/folders/{folder_id}/detail',
        ...options
    });
};

/**
 * Remove Folder Outfits
 */
export const removeFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsDelete = <ThrowOnError extends boolean = false>(options: Options<RemoveFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsDeleteResponse, RemoveFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/wardrobe/folders/{folder_id}/outfits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * File Folder Outfits
 */
export const fileFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsPost = <ThrowOnError extends boolean = false>(options: Options<FileFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FileFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsPostResponse, FileFolderOutfitsApiV1WardrobeFoldersFolderIdOutfitsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/wardrobe/folders/{folder_id}/outfits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Mailgun Webhook
 */
export const mailgunWebhookApiV1WebhooksMailgunPost = <ThrowOnError extends boolean = false>(options: Options<MailgunWebhookApiV1WebhooksMailgunPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MailgunWebhookApiV1WebhooksMailgunPostResponse, MailgunWebhookApiV1WebhooksMailgunPostError, ThrowOnError>({
        url: '/api/v1/webhooks/mailgun',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};